/*
 * RESADE rs-cart.js: Warenkorb-Drawer und Warenkorbseite (05 8.3, 6.16; 04 A5; 02 Abschnitte 7 bis 9;
 * 01 E-01, E-19, E-23, E-36, E-62, E-65). Klassisches Skript mit defer, ohne Bibliothek, unabhängig von
 * Shrines Warenkorb-JavaScript (E-01).
 *
 * Geladen von sections/rs-warenkorb-drawer.liquid (Kopf-Gruppe, jede Seite). Daten, Texte und Vorlagen
 * kommen aus derselben Section: script[data-rs-wk-daten], script[data-rs-wk-texte], template[data-rs-wk-vorlage].
 * Die Karten „Passt dazu“ und die Versandzeile rechnet window.RSPreise (assets/rs-preise.js, ES-Modul).
 *
 * API-Regeln (nach-4.md, verbindlich):
 * - Hinzufügen nur /cart/add.js mit items, Ändern und Entfernen nur /cart/change.js, eine Position je
 *   Aufruf, id = Zeilen-Key aus der letzten Antwort. Alle Aufrufe in einer Warteschlange, strikt nacheinander.
 * - Nie /cart/update.js für Positionen, nie /cart/clear.js. update.js nur für den Rabattcode ({ discount }).
 * - Nach 422 oder 400: GET /cart.js plus Sections, den Aufruf nie wiederholen. Nie Shopify.actions.updateCart.
 * - window.fetch wird bei jedem Aufruf neu gelesen (Web-Pixel hängen sich an window.fetch).
 *
 * Ablauf je Aktion (Ladezeit-Runde 03.10.2026, B4): change.js und update.js schicken sections (IDs aus dem DOM)
 * und sections_url mit (Bundled Section Rendering). Eine erfolgreiche Antwort gilt als Warenkorb, die Sections stehen
 * darin unter sections: eine Anfrage je Änderung (früher drei: Aufruf, GET /cart.js, GET Sections). Danach einsetzen
 * (nur Elemente mit data-rs-wk-teil), Karten zeichnen, Ereignisse, Ansage. Den alten Weg (GET /cart.js,
 * Bambus-Regel, Sections per GET) gehen 400 und 422, eine Antwort ohne Warenkorb, jede Antwort, für die
 * bambusOhnePfanne etwas meldet, das Hinzufügen (add.js) und der Tausch. Fehlt eine Section in der Antwort, holt ein
 * GET nur die Sections nach.
 *
 * Section Rendering API (05 6.16): GET /?sections=<Drawer-ID> auf allen Seiten, GET /cart?sections=<Seiten-ID>
 * auf der Warenkorbseite; derselbe Pfad geht als sections_url in change.js und update.js. Die IDs kommen aus dem
 * DOM (Hülle div#shopify-section-<ID>), denn Sections aus Gruppen heißen etwa „sections--123__rs_warenkorb_drawer“,
 * Template-Sections „template--123__main“.
 * Die Section-Anfrage nie mit „Accept: application/json“: Damit liefert Shopify auf /cart das Warenkorb-JSON und auf
 * Produktseiten das Produkt-JSON statt der Sections, und der Drawer zeichnete sich nie neu (Befund Welle 2).
 * Fehlt eine angefragte Section in der Antwort, gilt das als Fehler, nie still der alte Stand.
 * Kein Bundled-Rendering im add.js-Aufruf mit items (05 6.16).
 *
 * Beträge immer „72,99 €“ mit geschütztem Leerzeichen (04 Teil A), über window.RSPreise.formatEuro,
 * nie über shop.money_format.
 *
 * Ereignisse (05 8.6, auf document mit bubbles: true):
 *   hört:   rs:warenkorb:hinzugefuegt (von rs-buybox; detail.landung, optional detail.auswahl,
 *           detail.antwort = Antwort von add.js, detail.farbe 1|2), rs:warenkorb:oeffnen (detail.ausloeser)
 *   sendet: rs:warenkorb:geaendert { anzahl, gesamt, korb }, rs:versand:frei { gesamt },
 *           rs:warenkorb:hinzugefuegt { landung: null, quelle: 'warenkorb' } nach dem Dazulegen im Warenkorb,
 *           rs:warenkorb:geoeffnet, rs:warenkorb:geschlossen
 *   Handschlag für E-23: rs-cart.js setzt beim Hören von rs:warenkorb:hinzugefuegt detail.geoeffnet auf ein
 *   Promise, das erfüllt ist, sobald der Drawer offen ist (oder das Einsetzen gescheitert ist). Die Buybox
 *   liest es direkt nach dispatchEvent und gibt den Knopf danach frei.
 * Die Ereignisse sind nur intern und gehen nie an Tracking-Dienste (05 8.6).
 *
 * Öffentlich: window.RSWarenkorb = { oeffnen(ausloeser), schliessen(), aktualisieren() }.
 *
 * Vorladen (Ladezeit-Runde 03.10.2026, B9): Geht nach dem Hinzufügen das Popup auf, lädt Chrome die Warenkorbseite
 * per Speculation Rules vor (nur HTML); die Warenkorbseite gleicht einen vorgeladenen Stand beim Start ab.
 *
 * Seit Runde 6 (E-158): Standard ist das kleine Popup wie live (div[data-rs-wk-popup], nicht modal) statt der
 * Schublade; die Schublade bleibt als Rückweg (Einstellung modus). Ohne Schublade führen der Topf im Kopf,
 * rs:warenkorb:oeffnen und RSWarenkorb.oeffnen auf die Warenkorbseite. Im Versandbalken rollt die Tomate mit dem
 * Balken zum neuen Stand und hüpft zweimal; erreicht der Warenkorb die Schwelle, hoppelt sie in den kleinen Topf, und
 * rs:versand:frei kommt erst nach der Landung.
 *
 * Außerdem: Der Drawer beginnt bei jedem Öffnen oben (Scrollbereich .rs-wk-drawer__rumpf). Die Ansichten
 * tragen data-rs-tastatur nach Tastaturbedienung (Fokusring an den Titeln nur dann, rs-warenkorb.css).
 * Lädt die Warenkorbseite neu (aus dem leeren Zustand zurück), trägt ein Merker in sessionStorage
 * („rs-wk-neu-geladen“) Fokus und Ansage über das Neuladen. Escape im PayPal-iframe: bekannte Grenze,
 * siehe beim keydown-Handler.
 *
 * Seit 09.10.2026 (Runde Seitenleiste, Denny: „die Warenkorbseite weg … wieder wie damals die Seitenleiste“) ist die Schublade der
 * Warenkorb (Modus „drawer“). Neu dafür: Beim ersten Öffnen setzt drawerVorbereiten den unteren Teil (Bewertungen,
 * Vertrauenskarten, Fragen; template[data-rs-wk-spaeter]) und die Express-Knöpfe ein und lädt rs-versandschluss.js
 * sowie rs-fragen.css/.js, falls die Seite sie nicht schon hat. Der Rabattcode arbeitet in der Ansicht, in der sein
 * Formular steht. Nach dem Hinzufügen öffnet die Schublade erst mit dem Blatt und lässt danach die Tomate rollen
 * (versandNachOeffnen, wie das Popup). /cart leitet mit #warenkorb zurück, das öffnet die Schublade beim Start.
 * Ausnahme von 05 8.6 auf Dennys Wahl („Beim Öffnen der Leiste senden“): Jedes Öffnen mit Ware schreibt
 * view_cart_stape mit den Warenkorbdaten in den dataLayer (warenkorbAngesehen). Bisher kam dieses Ereignis nur vom
 * Stape-App-Pixel aus Shopifys cart_viewed, das nur der Aufruf von /cart auslöst; daran hängt allein der GA4-Tag
 * view_cart im Web-Container.
 *
 * Runde Seitenleiste 2 (10.10.2026, Denny: Animation „ein bisschen kaputt“, „wie ein Pop-up“; PayPal-Express raus):
 * oeffnen bereitet alles vor showModal vor, die Ebene rollt nicht mehr (overflow: clip, sonst Rücksetzen), die
 * Schublade fährt mit eigener Zeit herein und hinaus (--rs-wk-auf, --rs-wk-zu), und erst nach der Fahrt (fahrtEnde)
 * kommen Kartenprüfung, Tomate und view_cart_stape (weiter genau einmal je Öffnen). schliessen wartet auf das Ende der
 * Fahrt statt fester 300 ms. Keine Vorlagen und keine Express-Knöpfe mehr in der Schublade; drawerVorbereiten lädt
 * rs-fragen.* und rs-versandschluss.js, schon beim Hinzufügen oder im Leerlauf. Die Schublade zeigt höchstens
 * D.kartenMax Karten (Standard 1). Positionsbilder laden vorab (bilderVorladen, bilderWaermen).
 *
 * Runde Seitenleiste 3 (10.10.2026, Denny): Die fünf neuesten Bewertungen stehen als Vorlage im HTML
 * (template[data-rs-wk-bew-vorlage]); drawerVorbereiten setzt sie ein, solange die Ebene zu ist, bewAnbinden gibt langen
 * Texten „Ganze Bewertung lesen“ (gemessen erst in der Nähe). Pfeile und Pfeiltasten blättern um eine Karte, an den
 * Enden von vorn (bewBlaettern), mit Ansage. Der Rabattcode steht zuletzt im Rumpf: Nach „Einlösen“ und beim Aufklappen
 * rollt der Rumpf Meldung oder Formular ins Bild (imRumpfZeigen), denn ein Nachlass im festen Fuß macht den Rumpf kürzer.
 *
 * Duo 20 % (01.10.2026): „Zwei Pfannen“ liegt als Pfannen-Duo im Warenkorb, als eine Zeile (Bundle pfannen-duo,
 * Messung M1). Popup und Warenkorb nennen es „Zwei Pfannen, 24 und 28 cm“, darunter ungestrichen „einzeln …, Du sparst …“
 * (D4, Ausnahme von E-36). Die Karten tauschen (tauschAblauf): eine Einzelpfanne gegen ein Pfannen-Duo, zwei
 * Einzelpfannen einer Farbe gegen ihr Pfannen-Duo, ein Pfannen-Duo aus zwei Größen gegen das Set. Immer erst hinzufügen,
 * dann herausnehmen; lehnt Shopify das Hinzufügen wegen Bestand ab (422), bleibt alles, wie es war, und die Karte
 * erscheint bis zum Neuladen nicht mehr. Eigene Bestätigungen eines Nachlasses gibt es keine, Shopifys Zuteilungen
 * (Rabattcodes) zeigt der Warenkorb weiter an der Position.
 */
(() => {
  'use strict';
  if (window.RSWarenkorb) return;

  const doc = document;
  const html = doc.documentElement;

  function jsonAus(wurzel, sel) {
    const el = (wurzel || doc).querySelector(sel);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  const D = jsonAus(doc, 'script[data-rs-wk-daten]');
  const T = jsonAus(doc, 'script[data-rs-wk-texte]');
  if (!D || !T) return;

  const drawer = doc.querySelector('dialog[data-rs-wk="drawer"]');
  const seite = doc.querySelector('[data-rs-wk="seite"]');
  // E-158: kleines Popup nach dem Hinzufügen (Standard), sonst die Schublade
  const popup = doc.querySelector('[data-rs-wk-popup]');
  // Rückmeldung 02.10.2026 (Ladezeit am Handy): Auf Kaufseiten lädt rs-warenkorb.css ohne zu blockieren
  // (link data-rs-wk-css, rs-warenkorb-drawer.liquid). Schublade und Popup öffnen erst mit dem Blatt. Ein einziges
  // Warten ab dem Start dieses Skripts: fertig mit load, error oder nach 3 s, danach nie mehr (auch wenn das Blatt
  // fehlt, sonst öffnete die Schublade nie). Ohne diesen link (andere Seiten) sofort.
  const wkCss = doc.querySelector('link[data-rs-wk-css]');
  let wkCssFertig = !wkCss || (wkCss.media === 'all' && !!wkCss.sheet);
  const wkCssWarten = wkCssFertig
    ? Promise.resolve()
    : new Promise((fertig) => {
        const ende = () => {
          wkCssFertig = true;
          fertig();
        };
        wkCss.addEventListener('load', ende, { once: true });
        wkCss.addEventListener('error', ende, { once: true });
        window.setTimeout(ende, 3000);
      });
  const wkCssDa = () => wkCssFertig || (wkCss.media === 'all' && !!wkCss.sheet);
  function wkCssBereit() {
    return wkCssDa() ? Promise.resolve() : wkCssWarten;
  }
  const P = D.preise || {};
  // Duo 20 % (01.10.2026): {rabatt} in den Texten ist der Nachlass in Prozent auf beide Pfannen des Pfannen-Duos
  // („20 % auf beide“). Ihn trägt der Preis des Pfannen-Duos, der Warenkorb rechnet keinen eigenen Nachlass.
  const prozent = Number(P.prozent) || 0;

  /* ---------- Helfer ---------- */

  const alle = (sel, wurzel) => Array.from((wurzel || doc).querySelectorAll(sel));
  const feld = (el, name) => (el ? el.querySelector('[data-feld="' + name + '"]') : null);
  const fuellen = (muster, werte) =>
    String(muster == null ? '' : muster).replace(/\{(\w+)\}/g, (m, k) => (werte && werte[k] != null ? String(werte[k]) : m));
  const mitKomma = (t) => (/cm$/.test(String(t)) ? t + ',' : String(t));
  // Zahl und Einheit nie trennen (E-127): geschütztes Leerzeichen in den Kartentexten „20 % auf beide“,
  // „20 cm“ (Feinschliff 26.09.2026). Nur für sichtbaren Kartentext, aria-labels bleiben unberührt.
  // E-161: „Zweite Pfanne ({farbe}) dazu“; fehlt die Farbe, fällt die leere Klammer weg
  const ohneLeereKlammer = (t) => String(t == null ? '' : t).replace(/\s*\(\s*\)/g, '');
  const fest = (t) => String(t == null ? '' : t).replace(/(\d) (%|cm|°C|€)/g, '$1 $2');
  // Duo 20 % (01.10.2026): Name einer Duo-Zeile wie in rs-warenkorb-inhalt.liquid („Zwei Pfannen, 24 und 28 cm“). Ist das
  // Feld im Editor leer, gilt wie dort der Produktname (rueckfall, etwa product_title aus der Antwort von /cart/add.js).
  const duoName = (a, b, rueckfall) => fuellen(Number(a) === Number(b) ? T.name_duo_gleich : T.name_duo, { a, b }) || String(rueckfall || '');
  // Randmaß der Pfannen in cm (Kreise der Karten, Platzhalter im Popup)
  const RAND_CM = { 20: 23.5, 24: 27.5, 28: 31 };
  const ruhig = () => {
    if (D.bewegung === false) return true;
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  };
  const ansichten = () => [drawer, seite].filter(Boolean);
  const ansichtVon = (el) => (el && el.closest ? el.closest('[data-rs-wk]') : null);

  function senden(name, detail) {
    doc.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }

  // Ereignisse an document und window hören, jedes nur einmal verarbeiten
  const gesehen = new WeakSet();
  function hoeren(name, fn) {
    const h = (e) => {
      if (gesehen.has(e)) return;
      gesehen.add(e);
      fn(e);
    };
    doc.addEventListener(name, h);
    window.addEventListener(name, h);
  }

  /* ---------- Geld: „72,99 €“ mit geschütztem Leerzeichen (04 Teil A, Formatregel) ----------
     Dieselbe Schreibweise wie formatEuro in rs-preise.js (Buybox, Kaufleiste, Preistreppe) und das
     Snippet rs-preis (Liquid). Bewusst nicht shop.money_format: Das Shop-Format schreibt „72,99€“. */

  function betragText(cent) {
    const c = Math.round(Number(cent) || 0);
    const abs = Math.abs(c);
    const ganz = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (c < 0 ? '-' : '') + ganz + ',' + String(abs % 100).padStart(2, '0');
  }
  function geld(cent) {
    const R = window.RSPreise;
    const t = R && typeof R.formatEuro === 'function' ? R.formatEuro(cent) : '';
    return t || betragText(cent) + ' €';
  }
  // für Namen und Ansagen am Knopf: „87,98 Euro“ (04 A5.5)
  function geldGesprochen(cent) {
    const R = window.RSPreise;
    const t = R && typeof R.formatEuroSprache === 'function' ? R.formatEuroSprache(cent) : '';
    return t || betragText(cent) + ' Euro';
  }

  /* ---------- Varianten aus den Theme-Settings ---------- */

  const variantenInfo = new Map();
  Object.keys(P.einzel || {}).forEach((f) => {
    Object.keys(P.einzel[f] || {}).forEach((g) => {
      const e = P.einzel[f][g];
      if (e && e.id != null) variantenInfo.set(String(e.id), { art: 'einzel', g: Number(g), f: String(f) });
    });
  });
  Object.keys(P.set || {}).forEach((f) => {
    const e = P.set[f];
    if (e && e.id != null) variantenInfo.set(String(e.id), { art: 'set', f: String(f) });
  });
  if (P.bambus && P.bambus.id != null) variantenInfo.set(String(P.bambus.id), { art: 'bambus' });
  // Duo 20 % (01.10.2026): Pfannen-Duo je Paar und Farbe, Schlüssel „a-b|f“ wie rs-preise.js duoSchluessel
  Object.keys(P.duoVarianten || {}).forEach((schluessel) => {
    const m = /^(\d+)-(\d+)\|([12])$/.exec(schluessel);
    const e = P.duoVarianten[schluessel];
    if (!m || !e || e.id == null) return;
    const a = Number(m[1]);
    const b = Number(m[2]);
    variantenInfo.set(String(e.id), { art: 'duo', a: Math.min(a, b), b: Math.max(a, b), f: m[3] });
  });

  function auswahlName(id, rueckfall) {
    const i = variantenInfo.get(String(id));
    if (!i) return rueckfall || '';
    const farbe = (D.farben && D.farben[i.f]) || '';
    if (i.art === 'einzel') return fuellen(T.ansage_pfanne, { produkt: (D.held[i.g] || '') + ', ' + i.g + ' cm', farbe });
    if (i.art === 'set') return fuellen(T.ansage_set, { farbe });
    if (i.art === 'duo') {
      // ohne Namen (Feld leer, kein Rückfall) keine Ansage „, in Schwarz“
      const name = duoName(i.a, i.b, rueckfall);
      return name ? fuellen(T.ansage_pfanne, { produkt: name, farbe }) : '';
    }
    return T.name_bambus;
  }

  /* ---------- Rechenkern (rs-preise.js) ---------- */

  let preiseLaden = null;
  function preise() {
    if (window.RSPreise) return Promise.resolve(window.RSPreise);
    if (!preiseLaden && D.preiseUrl) {
      preiseLaden = import(D.preiseUrl)
        .then((m) => window.RSPreise || (m && (m.default || m)) || null)
        .catch(() => null);
    }
    return preiseLaden || Promise.resolve(null);
  }

  let zuletztFarbe = null;
  // Duo 20 % (01.10.2026, Gegenprüfung H2): Ziele eines Tauschs, den Shopify wegen Bestand abgelehnt hat (422). Ihre
  // Karten erscheinen bis zum Neuladen nicht mehr, ein neuer Versuch ginge wieder schief.
  const gesperrteZiele = new Set();

  function kartenRechnen(R, k) {
    if (!R || !k || typeof R.warenkorbKarten !== 'function') return null;
    try {
      const positionen = R.positionenAusCart(k, R.variantenAusDaten(P));
      return R.warenkorbKarten({
        positionen,
        gesamt: k.total_price,
        daten: P,
        zuletztFarbe,
        tauschAn: D.tauschAn !== false,
        bambusAn: !!D.bambusAn && !!vorlage('bambus'),
        gesperrt: Array.from(gesperrteZiele),
        texte: { frei: T.versand_erreicht, noch_ein_produkt: T.versand_knapp, rueckfall: T.versand_rueckfall }
      });
    } catch (e) {
      return null;
    }
  }

  // Prüfung E-158 (Conversion A4): „Noch ein Produkt …“ stimmt nur für die erste Karte. Ist sie „Zweite Pfanne dazu“,
  // nennt der Satz die zweite Pfanne; jede angebotene hebt die Summe über die Schwelle (rs-preise.js versandZeile).
  function versandText(ergebnis) {
    const v = ergebnis && ergebnis.versand;
    if (!v || v.frei || !v.text) return '';
    const erste = ergebnis.karten && ergebnis.karten[0];
    if (v.zeile === 'noch_ein_produkt' && erste && erste.art === 'zweite' && T.versand_zweite) return T.versand_zweite;
    return v.text;
  }

  // Wörter mit Bindestrich („Weiß-Grau“) als Ganzes, damit die Zeile nicht am Bindestrich umbricht
  function textOhneBindestrichUmbruch(el, text) {
    el.textContent = '';
    String(text || '').split(/(\S+-\S+)/).forEach((teil, i) => {
      if (!teil) return;
      if (i % 2) {
        const w = doc.createElement('span');
        w.className = 'rs-wk-nw';
        w.textContent = teil;
        el.appendChild(w);
      } else el.appendChild(doc.createTextNode(teil));
    });
  }

  const schwelle = () => Number(P.schwelle) || 0;
  const versandFreiGeworden = (v, n) =>
    !!(schwelle() && v && n && Number(v.total_price) < schwelle() && Number(n.total_price) >= schwelle());
  function gesamtAnzeige(k) {
    const t = Number(k.total_price) || 0;
    const frei = schwelle() && t >= schwelle();
    return t + (!frei && k.item_count > 0 && D.versandCent > 0 ? D.versandCent : 0);
  }

  // Bambus-Regel (05 8.3, 02 7.4): bleiben nur Bambus-Küchenhelfer übrig, gehen sie heraus.
  // Nur wenn sonst gar nichts im Warenkorb liegt, wie rs-preise.js warenkorbKarten.
  function bambusOhnePfanne(k) {
    if (!D.bambusProdukt || !k || !Array.isArray(k.items) || !k.items.length) return [];
    const b = k.items.filter((i) => Number(i.product_id) === Number(D.bambusProdukt));
    return b.length && b.length === k.items.length ? b : [];
  }

  /* ---------- Netz ---------- */

  class NetzFehler extends Error {}

  async function anfrage(url, optionen) {
    let r;
    try {
      r = await window.fetch(url, Object.assign({ credentials: 'same-origin' }, optionen));
    } catch (e) {
      throw new NetzFehler('netz');
    }
    let json = null;
    try {
      json = await r.json();
    } catch (e) {
      json = null;
    }
    return { ok: r.ok, status: r.status, json };
  }

  const post = (url, body) =>
    anfrage(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });

  async function holeKorb() {
    const r = await anfrage(D.routen.korb, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok || !r.json) throw new Error('korb');
    return r.json;
  }

  // Tatsächliche Section-ID aus dem DOM: Shopify legt jede Section in div#shopify-section-<ID>.
  // Bei Sections aus Gruppen ist das etwa „sections--123__rs_warenkorb_drawer“. data-section-id
  // ({{ section.id }}) ist nur der Rückfall, falls die Hülle fehlt.
  const HUELLE = 'shopify-section-';
  function sektionsId(el) {
    if (!el) return '';
    const h = el.closest('[id^="' + HUELLE + '"]');
    return (h && h.id.slice(HUELLE.length)) || el.getAttribute('data-section-id') || '';
  }
  const idDrawer = sektionsId(drawer);
  const idSeite = sektionsId(seite);

  // Pfad der Anfrage: Die Warenkorbseite nur auf /cart (Template-Section), der Drawer aus der Kopf-Gruppe
  // auf der Startseite. Dort antwortet Shopify immer mit 200, auch wenn die aktuelle Seite ein 404 ist.
  const sektionenPfad = () => (seite ? D.routen.warenkorb : D.routen.wurzel || '/');
  function sektionenUrl(ids) {
    const pfad = sektionenPfad();
    return pfad + (pfad.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + ids.map(encodeURIComponent).join(',');
  }

  function sektionenIds() {
    const ids = [];
    if (drawer && idDrawer) ids.push(idDrawer);
    if (seite && idSeite) ids.push(idSeite);
    return ids;
  }

  async function holeSektionen() {
    const ids = sektionenIds();
    if (!ids.length) return {};
    // Ohne Accept-Kopf (Standard */*): Mit „Accept: application/json“ antwortet Shopify auf /cart mit dem
    // Warenkorb und auf Produktseiten mit dem Produkt statt mit den Sections.
    const r = await anfrage(sektionenUrl(ids), { cache: 'no-store' });
    if (!r.ok || !r.json || typeof r.json !== 'object') throw new Error('sektionen');
    ids.forEach((id) => {
      if (typeof r.json[id] !== 'string' || !r.json[id]) throw new Error('sektionen');
    });
    return r.json;
  }

  // Ladezeit-Runde 03.10.2026 (B4): Bundled Section Rendering. change.js und update.js bekommen die Sections der
  // Ansichten auf der Seite (IDs aus dem DOM, höchstens zwei; Shopify nimmt bis zu fünf) und denselben Pfad wie die
  // GET-Anfrage als sections_url. Die Antwort trägt den Warenkorb und darunter sections mit dem HTML je ID.
  function mitSektionen(body) {
    const ids = sektionenIds();
    if (!ids.length) return { body, ids };
    return { body: Object.assign({}, body, { sections: ids, sections_url: sektionenPfad() }), ids };
  }

  // Antwort in Warenkorb und Sections trennen. korb ist null ohne Positionsliste, sektionen ist null, sobald eine
  // angefragte Section fehlt oder leer ist (Shopify schreibt bei einem Renderfehler null).
  function antwortTeilen(json, ids) {
    if (!json || typeof json !== 'object') return { korb: null, sektionen: null };
    const k = Object.assign({}, json);
    const roh = k.sections;
    delete k.sections;
    let sektionen = null;
    if (ids.length && roh && typeof roh === 'object' && ids.every((id) => typeof roh[id] === 'string' && roh[id])) {
      sektionen = {};
      ids.forEach((id) => {
        sektionen[id] = roh[id];
      });
    }
    return { korb: Array.isArray(k.items) && k.item_count != null ? k : null, sektionen };
  }

  let wartetAufNetz = false;
  function beiVerbindung() {
    if (wartetAufNetz) return;
    wartetAufNetz = true;
    window.addEventListener(
      'online',
      () => {
        wartetAufNetz = false;
        einreihen(() => nachladen({ art: 'stand', leise: true })).then(fehlerLeeren).catch(fehlerAllgemein);
      },
      { once: true }
    );
  }

  /* ---------- Warteschlange: alles strikt nacheinander ---------- */

  let korb = null;
  let kette = Promise.resolve();
  let laufend = 0;

  function einreihen(aufgabe) {
    laufend++;
    html.classList.add('rs-warenkorb-laedt');
    const p = kette.then(aufgabe);
    kette = p
      .catch(() => {})
      .then(() => {
        laufend--;
        if (!laufend) html.classList.remove('rs-warenkorb-laedt');
      });
    return p;
  }

  /* ---------- Einsetzen der frisch gerenderten Sections ---------- */

  function teileErsetzen(alt, neu, warLeer) {
    alle('[data-rs-wk-teil]', alt).forEach((el) => {
      const n = neu.querySelector('[data-rs-wk-teil="' + el.getAttribute('data-rs-wk-teil') + '"]');
      if (n) el.replaceWith(doc.importNode(n, true));
    });
    alle('[data-rs-wk-sichtbar]', alt).forEach((el) => {
      const n = neu.querySelector('[data-rs-wk-sichtbar="' + el.getAttribute('data-rs-wk-sichtbar') + '"]');
      if (n) el.hidden = n.hidden;
    });
    // Express-Knöpfe nur neu setzen, wenn der Warenkorb vorher leer war (sonst bleiben sie unberührt)
    if (warLeer) {
      const e = alt.querySelector('[data-rs-wk-express]');
      const n = neu.querySelector('[data-rs-wk-express]');
      if (e && n) e.replaceWith(doc.importNode(n, true));
    }
  }

  // Rückgabe NEU_LADEN: Die Warenkorbseite kommt aus dem leeren Zustand zurück und wird neu geladen
  // (anwenden setzt vorher den Merker für Fokus und Ansage, siehe merkerSchreiben).
  const NEU_LADEN = 'neu-laden';

  function einsetzen(sektionen, warLeer) {
    const parser = new DOMParser();
    if (drawer && sektionen[idDrawer]) {
      const neu = parser.parseFromString(sektionen[idDrawer], 'text/html').querySelector('[data-rs-wk="drawer"]');
      if (!neu) throw new Error('sektionen');
      teileErsetzen(drawer, neu, warLeer);
      bilderVorladen();
    }
    if (seite && sektionen[idSeite]) {
      const neu = parser.parseFromString(sektionen[idSeite], 'text/html').querySelector('[data-rs-wk="seite"]');
      if (!neu) throw new Error('sektionen');
      if (seite.dataset.rsWkLeer === 'true' && neu.dataset.rsWkLeer !== 'true') {
        // Aus dem leeren Zustand zurück: neu laden, damit Shopify die Express-Knöpfe sauber aufbaut
        return NEU_LADEN;
      }
      if (seite.dataset.rsWkLeer !== neu.dataset.rsWkLeer) {
        seite.innerHTML = neu.innerHTML;
        seite.dataset.rsWkLeer = neu.dataset.rsWkLeer;
      } else {
        teileErsetzen(seite, neu, false);
      }
    }
    return '';
  }

  /* ---------- Vorlagen, Karten, Hinweise ---------- */

  function vorlage(name) {
    const t = doc.querySelector('template[data-rs-wk-vorlage="' + name + '"]');
    return t && t.content && t.content.firstElementChild ? t : null;
  }
  function klon(name) {
    const t = vorlage(name);
    return t ? t.content.firstElementChild.cloneNode(true) : null;
  }

  const kartenDaten = new WeakMap();

  // Duo 20 % (01.10.2026): Kreise einer Karte nach den Größen (Randmaß), beim Pfannen-Duo zwei
  function kreiseSetzen(li, groessen) {
    const kreise = li.querySelector('.rs-wk-kreise');
    if (!kreise) return;
    kreise.textContent = '';
    groessen.forEach((g) => {
      const i = doc.createElement('i');
      i.style.setProperty('--d', String(RAND_CM[g] || 27.5));
      kreise.appendChild(i);
    });
  }

  // Text in ein Feld der Karte, Zahl und Einheit geschützt; ohne Text fällt das Feld weg
  function feldText(li, name, text) {
    const el = feld(li, name);
    if (!el) return;
    const t = String(text == null ? '' : text).trim();
    if (t) el.textContent = fest(t);
    else el.remove();
  }

  function karteBauen(k, ansicht, nr) {
    const farbe = (k.farbe && D.farben && D.farben[k.farbe]) || '';
    if (k.art === 'zweite') {
      const li = klon('zweite');
      if (!li) return null;
      li.dataset.farbe = k.farbe || '';
      textOhneBindestrichUmbruch(feld(li, 'titel'), ohneLeereKlammer(fest(fuellen(T.zweite_titel, { rabatt: prozent, farbe }))));
      const frage = feld(li, 'frage');
      frage.textContent = T.zweite_frage;
      frage.id = 'rs-wk-frage-' + ansicht.dataset.rsWk + '-' + nr;
      const wahlen = feld(li, 'wahlen');
      wahlen.setAttribute('aria-labelledby', frage.id);
      (k.optionen || []).forEach((o) => {
        const b = klon('zweite-knopf');
        if (!b || o.id == null) return;
        feld(b, 'titel').textContent = fest(fuellen(T.zweite_knopf, { groesse: o.groesse }));
        feld(b, 'preis').textContent = fuellen(T.zweite_preis, { summe: geld(o.beideZusammen) });
        b.setAttribute(
          'aria-label',
          fuellen(T.zweite_label, {
            groesse: o.groesse,
            held: (D.held && D.held[o.groesse]) || '',
            farbe,
            summe_gesprochen: geldGesprochen(o.beideZusammen)
          })
        );
        b.dataset.id = String(o.id);
        b.dataset.farbe = k.farbe || '';
        b.setAttribute('data-rs-fokus', 'dazu-' + o.groesse);
        // Duo 20 % (01.10.2026): Der Knopf tauscht die Pfanne gegen das Pfannen-Duo mit dieser Größe (tauschKlick)
        kartenDaten.set(b, { art: 'zweite', neuId: o.id, entfernen: o.entfernen || [], farbe: k.farbe });
        wahlen.appendChild(b);
      });
      // E-161: die Farbe steht im Titel; ist die Zeile darunter leer, fällt sie weg
      const farbZeile = fuellen(T.zweite_farbe, { farbe }).trim();
      if (farbZeile) feld(li, 'farbe').textContent = farbZeile;
      else feld(li, 'farbe').remove();
      // Duo 20 % (01.10.2026): was beim Dazulegen passiert, bevor jemand tippt (07 3.7)
      feldText(li, 'erklaerung', fuellen(T.zweite_erklaerung, { farbe }));
      return wahlen.children.length ? li : null;
    }
    if (k.art === 'duo') {
      // Duo 20 % (01.10.2026): zwei Einzelpfannen einer Farbe als Pfannen-Duo, Vorlage wie der Set-Tausch
      const li = klon('tausch');
      if (!li || k.duoId == null || !Array.isArray(k.paar)) return null;
      const [a, b] = k.paar;
      li.dataset.farbe = k.farbe || '';
      li.setAttribute('data-rs-wk-karte', 'duo');
      kreiseSetzen(li, [a, b]);
      textOhneBindestrichUmbruch(feld(li, 'titel'), ohneLeereKlammer(fest(fuellen(T.duo_titel, { ersparnis: geld(k.ersparnis), farbe }))));
      feldText(li, 'text', fuellen(T.duo_text, { rabatt: prozent, summe: geld(k.duoPreis), farbe }));
      feldText(li, 'erklaerung', fuellen(T.duo_erklaerung, { farbe }));
      const knopf = feld(li, 'knopf');
      knopf.textContent = T.duo_knopf;
      const name = fuellen(a === b ? T.duo_label_gleich : T.duo_label, { a, b, farbe, summe_gesprochen: geldGesprochen(k.duoPreis) }).trim();
      if (name) knopf.setAttribute('aria-label', name);
      knopf.setAttribute('data-rs-fokus', 'tausch');
      kartenDaten.set(knopf, { art: 'duo', neuId: k.duoId, entfernen: k.entfernen || [], farbe: k.farbe });
      return li;
    }
    if (k.art === 'set' || k.art === 'tausch') {
      const li = klon('tausch');
      if (!li || k.setId == null) return null;
      // Duo 20 % (01.10.2026): der Set-Tausch aus einem Pfannen-Duo hat einen eigenen Text (W11); ohne ihn keine Karte
      if (k.art === 'set' && k.ausDuo && !T.set_text_duo) return null;
      li.dataset.farbe = k.farbe || '';
      let titel;
      let text;
      let erklaerung = '';
      if (k.art === 'set') {
        const a = k.paar[0];
        const b = k.paar[1];
        titel = fuellen(T.set_titel, { set_preis: geld(k.setPreis), farbe });
        text = fuellen(k.ausDuo ? T.set_text_duo : T.set_text, {
          held_a: D.held[a],
          groesse_a: a,
          held_b: D.held[b],
          groesse_b: b,
          held_neu: D.held[k.fehlt],
          groesse_neu: k.fehlt,
          aufpreis: geld(k.aufpreis),
          rabatt: prozent,
          farbe,
          // {einzeln}: die drei vollen Einzelpreise (R64). {dritte}: Preis der fehlenden Größe, also was eine dritte
          // Einzelpfanne mehr kostet (Duo 20 % (01.10.2026)). Fehlt ein Wert, bleibt der Platzhalter stehen;
          // geld(undefined) ergäbe einen falschen Betrag (0,00 €).
          einzeln: k.einzelnDrei != null ? geld(k.einzelnDrei) : null,
          dritte: k.mehrEinzeln != null ? geld(k.mehrEinzeln) : null
        });
        erklaerung = fuellen(k.ausDuo ? T.set_erklaerung_duo || T.set_erklaerung : T.set_erklaerung, { farbe });
      } else {
        titel = fuellen(k.variante === 'vier' ? T.vier_titel : T.drei_titel, { ersparnis: geld(k.ersparnis), farbe });
        text = fuellen(k.variante === 'vier' ? T.vier_text : T.drei_text, { farbe });
      }
      textOhneBindestrichUmbruch(feld(li, 'titel'), ohneLeereKlammer(fest(titel)));
      feld(li, 'text').textContent = fest(text);
      const e = feld(li, 'erklaerung');
      if (erklaerung) e.textContent = erklaerung;
      else e.remove();
      const knopf = feld(li, 'knopf');
      knopf.textContent = T.tausch_knopf;
      knopf.setAttribute('data-rs-fokus', 'tausch');
      kartenDaten.set(knopf, { art: k.art, ausDuo: !!k.ausDuo, neuId: k.setId, entfernen: k.entfernen || [], farbe: k.farbe });
      return li;
    }
    if (k.art === 'bambus') {
      const li = klon('bambus');
      if (!li || k.id == null) return null;
      feld(li, 'titel').textContent = fuellen(T.bambus_titel, { name: T.name_bambus, preis: geld(k.preis) });
      const knopf = feld(li, 'knopf');
      knopf.textContent = T.bambus_knopf;
      knopf.setAttribute('aria-label', fuellen(T.bambus_label, { name: T.name_bambus }));
      knopf.dataset.id = String(k.id);
      knopf.setAttribute('data-rs-fokus', 'bambus');
      return li;
    }
    return null;
  }

  const luecke = (liste) => parseFloat(window.getComputedStyle(liste).columnGap) || 12;

  function naviEinrichten(rahmen) {
    const liste = feld(rahmen, 'liste');
    const navi = feld(rahmen, 'navi');
    const zaehler = feld(rahmen, 'zaehler');
    if (!liste || !navi) return;
    const knoepfe = alle('[data-rs-wk-aktion^="karten-"]', navi);
    const index = () => {
      const breite = liste.children[0].getBoundingClientRect().width + luecke(liste);
      return Math.min(liste.children.length, Math.max(1, Math.round(liste.scrollLeft / (breite || 1)) + 1));
    };
    const pruefen = () => {
      const n = liste.children.length;
      const ueber = n > 1 && liste.scrollWidth > liste.clientWidth + 4;
      navi.hidden = !ueber;
      if (!ueber) return;
      zaehler.textContent = fuellen(T.karte_zaehler, { n: index(), gesamt: n });
      knoepfe.forEach((b) => {
        const zurueck = b.getAttribute('data-rs-wk-aktion') === 'karten-zurueck';
        const aus = zurueck ? liste.scrollLeft < 4 : liste.scrollLeft + liste.clientWidth >= liste.scrollWidth - 4;
        b.setAttribute('aria-disabled', String(aus));
      });
    };
    let wartet = false;
    liste.addEventListener(
      'scroll',
      () => {
        if (wartet) return;
        wartet = true;
        window.requestAnimationFrame(() => {
          wartet = false;
          pruefen();
        });
      },
      { passive: true }
    );
    liste.rsPruefen = pruefen;
    window.requestAnimationFrame(pruefen);
  }

  function blaettern(knopf, richtung) {
    if (knopf.getAttribute('aria-disabled') === 'true') return;
    const rahmen = knopf.closest('.rs-wk-karten');
    const liste = feld(rahmen, 'liste');
    if (!liste || !liste.children.length) return;
    const n = liste.children.length;
    const breite = liste.children[0].getBoundingClientRect().width + luecke(liste);
    const jetzt = Math.round(liste.scrollLeft / (breite || 1)) + 1;
    const ziel = Math.min(n, Math.max(1, jetzt + richtung));
    liste.scrollTo({ left: (ziel - 1) * breite, behavior: ruhig() ? 'auto' : 'smooth' });
    sprich(fuellen(T.ansage_vorschlag, { n: ziel, gesamt: n }));
  }

  function kartenZeichnen(ansicht, ergebnis) {
    const platz = ansicht.querySelector('[data-rs-wk-karten]');
    if (!platz) return;
    platz.textContent = '';
    if (D.kartenAn === false || !ergebnis || !Array.isArray(ergebnis.karten) || !ergebnis.karten.length) return;
    // Runde Seitenleiste 2 (10.10.2026, Denny: nur das passendste Angebot): die Schublade zeigt höchstens D.kartenMax
    // Karten in der Reihenfolge aus rs-preise.js (zweite Pfanne, Pfannen-Duo, Set, Set-Tausch, Bambus); die
    // Warenkorbseite alle. versandText liest weiter die erste Karte aus dem ganzen Ergebnis.
    const karten = ansicht === drawer && D.kartenMax > 0 ? ergebnis.karten.slice(0, D.kartenMax) : ergebnis.karten;
    const rahmen = klon('karten');
    if (!rahmen) return;
    const titel = feld(rahmen, 'titel');
    const tid = 'rs-wk-karten-' + ansicht.dataset.rsWk;
    if (ansicht === seite) {
      const h2 = doc.createElement('h2');
      h2.className = titel.className + ' rs-wk-seite__h2';
      h2.textContent = titel.textContent;
      titel.replaceWith(h2);
      h2.id = tid;
    } else {
      titel.id = tid;
    }
    const liste = feld(rahmen, 'liste');
    liste.setAttribute('aria-labelledby', tid);
    karten.forEach((k, i) => {
      const li = karteBauen(k, ansicht, i);
      if (li) liste.appendChild(li);
    });
    if (!liste.children.length) return;
    platz.appendChild(rahmen);
    naviEinrichten(rahmen);
  }

  // „Noch ein Produkt …“ nur, wenn die erste Karte die Summe wirklich über die Schwelle hebt (02 Abschnitt 7)
  function versandZeichnen(ansicht, ergebnis) {
    const box = ansicht.querySelector('[data-rs-wk-versand-botschaft]');
    if (!box || box.getAttribute('data-frei') === 'true') return;
    const span = box.querySelector('span');
    if (!span) return;
    if (versandText(ergebnis)) span.textContent = versandText(ergebnis);
  }

  let hinweise = [];

  function meldungenZeichnen() {
    alle('[data-rs-wk-hinweise]').forEach((box) => {
      box.textContent = '';
      hinweise.forEach((h) => {
        const p = klon('hinweis') || doc.createElement('p');
        (feld(p, 'text') || p).textContent = h.text;
        if (h.rueck) {
          const b = doc.createElement('button');
          b.type = 'button';
          b.className = 'rs-wk-textknopf';
          b.setAttribute('data-rs-wk-aktion', 'rueck');
          b.setAttribute('data-rs-fokus', 'rueck');
          b.textContent = T.wieder;
          p.appendChild(b);
        }
        box.appendChild(p);
      });
    });
  }

  function aktiveAnsicht() {
    if (offen && drawer) return drawer;
    return seite || drawer;
  }

  function fehlerIn(box, text) {
    if (!box) return;
    box.textContent = '';
    if (!text) return;
    const p = klon('fehler') || doc.createElement('p');
    (feld(p, 'text') || p).textContent = text;
    box.appendChild(p);
  }
  function fehlerZeigen(text) {
    fehlerLeeren();
    const a = aktiveAnsicht();
    fehlerIn(a && a.querySelector('[data-rs-wk-fehler]'), text);
  }
  function fehlerLeeren() {
    alle('[data-rs-wk-fehler]').forEach((b) => {
      b.textContent = '';
    });
  }
  function fehlerAllgemein(e) {
    if (e instanceof NetzFehler) {
      fehlerZeigen(T.fehler_netz);
      beiVerbindung();
    } else {
      fehlerZeigen(T.fehler_sonst);
    }
  }

  /* ---------- Ansagen (04 A5.11, A2.1) ---------- */

  // warten: Verzögerung in ms bis zum Einsetzen des Texts (Standard 80; nach dem Neuladen länger,
  // damit die Ansage nicht in der Lesung der frisch geladenen Seite untergeht)
  function sprich(text, warten) {
    if (!text) return;
    const region = (offen && drawer && drawer.querySelector('[data-rs-wk-ansage]')) || doc.querySelector('[data-rs-wk-kopfansage]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => {
      region.textContent = text;
    }, warten || 80);
  }

  function ansageText(vorher, neu, info) {
    const n = Number(neu.item_count) || 0;
    if (!offen && !seite && !popupOffen) return fuellen(T.ansage_kopf, { anzahl: n });
    const teile = [];
    if (info.bambusRaus) teile.push(T.bambus_raus);
    if (!n) {
      teile.push(T.ansage_leer);
      return teile.join(' ');
    }
    const g = geld(gesamtAnzeige(neu));
    if (info.art === 'hinzu') {
      teile.push(fuellen(T.ansage_hinzu, { auswahl: info.auswahl || '', anzahl: n, gesamt: g }));
    } else if (info.art === 'menge') {
      const z = (neu.items || []).find((i) => String(i.variant_id) === String(info.variante));
      teile.push(fuellen(T.ansage_menge, { produkt: info.name, menge: z ? z.quantity : 0, gesamt: g }));
    } else if (info.art === 'entfernt') {
      teile.push(fuellen(T.ansage_entfernt, { produkt: mitKomma(info.name), gesamt: g }));
    } else if (info.art === 'tausch') {
      // Duo 20 % (01.10.2026): der Text des jeweiligen Tauschs (Set, Pfannen-Duo, zweite Pfanne)
      teile.push(info.okText || fuellen(T.tausch_ok, { farbe: info.farbe || '' }));
    } else {
      teile.push(fuellen(T.ansage_stand, { anzahl: n, gesamt: g }));
    }
    if (versandFreiGeworden(vorher, neu)) teile.push(T.versand_erreicht);
    return teile.join(' ');
  }

  /* ---------- Fokus ---------- */

  // Bedienart: WebKit (Safari, iOS) wertet auch den Fokus, den das Skript nach einem Mausklick oder Tippen
  // auf einen Titel mit tabindex -1 setzt, als :focus-visible und zeigt den Ring (Befund Runde 2); Chromium
  // nur nach Tastaturbedienung. Die Ansichten tragen deshalb data-rs-tastatur, solange zuletzt die Tastatur
  // bedient wurde, und rs-warenkorb.css zeigt den Ring an den Titeln nur dann. Der Fokus selbst wird immer
  // gesetzt, Screenreader lesen den Titel wie bisher.
  let tastatur = false;
  function bedienart(perTastatur) {
    tastatur = !!perTastatur;
    ansichten().concat(popup ? [popup] : []).forEach((a) => {
      if (tastatur) a.setAttribute('data-rs-tastatur', '');
      else a.removeAttribute('data-rs-tastatur');
    });
  }
  doc.addEventListener(
    'keydown',
    (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || tastatur) return;
      bedienart(true);
    },
    true
  );
  ['pointerdown', 'mousedown', 'touchstart'].forEach((typ) =>
    doc.addEventListener(
      typ,
      () => {
        if (tastatur) bedienart(false);
      },
      { capture: true, passive: true }
    )
  );

  // Merker für das Neuladen der Warenkorbseite (einsetzen gibt NEU_LADEN zurück, etwa nach „Wieder
  // hineinlegen“ aus dem leeren Zustand): Nach dem Laden stehen der Fokus auf der H1 „Warenkorb“ und die
  // Ansage in der Kopf-Region wie ohne Neuladen. sessionStorage kann fehlen oder werfen (privates Fenster,
  // gesperrte Website-Daten): Dann lädt die Seite trotzdem neu, nur ohne Fokus und Ansage.
  const MERKER = 'rs-wk-neu-geladen';
  function merkerSchreiben(werte) {
    try {
      window.sessionStorage.setItem(
        MERKER,
        JSON.stringify(Object.assign({ zeit: Date.now(), pfad: window.location.pathname }, werte))
      );
    } catch (e) {
      /* ohne Speicher: nur neu laden */
    }
  }
  function merkerEinloesen() {
    if (!seite) return;
    let m = null;
    try {
      const roh = window.sessionStorage.getItem(MERKER);
      if (roh) {
        window.sessionStorage.removeItem(MERKER);
        m = JSON.parse(roh);
      }
    } catch (e) {
      m = null;
    }
    // Nur frisch und nur auf derselben Seite, sonst gilt der Merker nicht (alter Stand im Speicher)
    if (!m || typeof m !== 'object' || m.pfad !== window.location.pathname) return;
    const alter = Date.now() - Number(m.zeit);
    if (!(alter >= 0 && alter < 30000)) return;
    bedienart(!!m.tastatur);
    if (m.fokus) fokusSetzen(seite, 'titel');
    if (m.ansage) sprich(String(m.ansage), 500);
  }

  function fokusSetzen(ansicht, ziel) {
    if (!ansicht) return;
    let el = null;
    if (ziel) {
      el = alle('[data-rs-fokus]', ansicht).find((x) => x.getAttribute('data-rs-fokus') === ziel && x.getClientRects().length);
    }
    if (!el) el = ansicht.querySelector('[data-rs-fokus="titel"]');
    if (el) el.focus({ preventScroll: el.getAttribute('data-rs-fokus') === 'titel' && ansicht === drawer });
  }

  /* ---------- Versandbalken mit Tomate (E-158, Denny bild3 und bild4) ----------
     Der Behälter [data-rs-wk-versand] trägt --anteil und data-frei. Nach einer Änderung kommt er neu (Section
     Rendering) mit dem neuen Stand; versandBewegen setzt kurz den alten Stand und lässt Balken und Tomate zum neuen
     rollen (Übergang auf clip-path und left, Klasse rollt). Unter der Schwelle hüpft die Tomate danach zweimal. Wird
     die Schwelle erreicht, hoppelt sie in den Topf (ist-unterwegs hält sie sichtbar und die Botschaft verborgen), der
     Deckel geht auf, schließt beim Eintauchen und springt nach der Landung (brodelt). Nur transform und opacity, einmal
     gemessen. Bei reduzierter Bewegung, unsichtbarem Behälter oder fehlender Web Animations API: sofort der neue Stand. */

  const anteilVon = (k) => {
    const s = schwelle();
    return s && k ? Math.min(1, Math.max(0, (Number(k.total_price) || 0) / s)) : 0;
  };
  const sichtbarEl = (el) => !!(el && el.getClientRects().length);
  const warte = (ms) => new Promise((r) => window.setTimeout(r, ms));

  // Zwei Hüpfer (je 450 ms), nur unter der Schwelle, nur sichtbar; mit einmal ein einzelner (E-161, Nachhüpfer)
  let letzterHuepfer = 0;
  function tomateHuepfen(box, einmal) {
    const t = box && box.querySelector('[data-rs-tomate]');
    if (!t || ruhig() || box.getAttribute('data-frei') === 'true' || !sichtbarEl(t)) return;
    const klasse = einmal ? 'huepft-einmal' : 'huepft';
    t.classList.remove('huepft', 'huepft-einmal');
    void t.offsetWidth;
    t.classList.add(klasse);
    letzterHuepfer = Date.now();
    window.setTimeout(() => t.classList.remove(klasse), einmal ? 490 : 940);
  }

  // Die Tomate hoppelt in den Topf: ein kleiner Hüpfer auf der Stelle, dann ein Bogen über den Rand hinein
  function tomateInDenTopf(box) {
    const t = box.querySelector('[data-rs-tomate]');
    const topf = box.querySelector('[data-rs-topf]');
    const gefaess = topf && topf.querySelector('.rs-topf__gefaess');
    if (!t || !gefaess || typeof t.animate !== 'function') return Promise.resolve();
    const a = t.getBoundingClientRect();
    const z = gefaess.getBoundingClientRect();
    const dx = z.left + z.width * 0.5 - (a.left + a.width / 2);
    const dy = z.top + z.height * 0.4 - (a.top + a.height / 2);
    const bogen = 22 + Math.max(0, -dy);
    const schritte = [];
    for (let i = 0; i <= 4; i++) {
      const p = i / 4;
      schritte.push({ offset: 0.3 * p, transform: 'translate(' + (dx * 0.12 * p).toFixed(1) + 'px, ' + (-10 * Math.sin(Math.PI * p)).toFixed(1) + 'px)', opacity: 1 });
    }
    for (let i = 1; i <= 10; i++) {
      const p = i / 10;
      const x = dx * (0.12 + 0.88 * p);
      const y = dy * p - 4 * bogen * p * (1 - p);
      const s = 1 - 0.45 * Math.max(0, (p - 0.55) / 0.45);
      schritte.push({ offset: 0.3 + 0.7 * p, transform: 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px) scale(' + s.toFixed(2) + ')', opacity: p >= 1 ? 0 : p > 0.85 ? 0.6 : 1 });
    }
    let anim;
    try {
      anim = t.animate(schritte, { duration: 950, easing: 'linear', fill: 'forwards' });
    } catch (e) {
      return Promise.resolve();
    }
    const auf = window.setTimeout(() => topf.classList.add('nimmt-auf'), 330);
    return new Promise((fertig) => {
      const ende = () => {
        window.clearTimeout(auf);
        topf.classList.remove('nimmt-auf', 'brodelt');
        void topf.offsetWidth;
        topf.classList.add('brodelt');
        window.setTimeout(() => topf.classList.remove('brodelt'), 940);
        fertig(anim);
      };
      anim.finished.then(ende, ende);
    });
  }

  // Balken und Tomate vom alten (von) zum neuen Stand (nach); o.wirdFrei: in den Topf, o.nachher: nach der Bewegung
  // (das Popup schaltet dort Botschaft und data-frei um). Erfüllt sich nach der Landung oder sofort, lehnt nie ab.
  function versandBewegen(box, von, nach, opt) {
    const o = opt || {};
    const fertig = () => {
      box.classList.remove('rollt', 'ist-unterwegs');
      if (o.nachher) o.nachher();
    };
    if (!box) return Promise.resolve();
    if (ruhig() || !sichtbarEl(box)) {
      box.style.setProperty('--anteil', String(nach));
      fertig();
      return Promise.resolve();
    }
    box.classList.add('rollt');
    if (o.wirdFrei) box.classList.add('ist-unterwegs');
    box.style.setProperty('--anteil', String(von));
    const t = box.querySelector('[data-rs-tomate]');
    // Ausgangsstand erst zeichnen, dann umstellen, damit die Übergänge laufen
    void window.getComputedStyle(t || box).left;
    void box.offsetWidth;
    box.style.setProperty('--anteil', String(nach));
    return warte(Math.abs(nach - von) > 0.001 ? 640 : 0)
      .then(() => {
        if (!o.wirdFrei) {
          fertig();
          tomateHuepfen(box);
          return null;
        }
        return tomateInDenTopf(box).then((anim) => {
          fertig();
          if (anim && typeof anim.cancel === 'function') window.requestAnimationFrame(() => anim.cancel());
        });
      })
      .catch(() => fertig());
  }

  /* ---------- Neuer Stand: einsetzen, Karten, Ereignisse, Ansage ---------- */

  async function anwenden(neu, sektionen, info) {
    const i = info || {};
    const vorher = i.vorher !== undefined ? i.vorher : korb;
    korb = neu;
    const aktiv = doc.activeElement;
    const warLeer = !vorher || !(vorher.item_count > 0);
    // Scheitert das Einsetzen, laufen Topf, Ereignisse und Ansage trotzdem mit dem echten Stand;
    // der Fehler kommt danach als Meldung (nie still der alte Stand).
    let fehler = null;
    let neuLaden = false;
    if (sektionen) {
      try {
        neuLaden = einsetzen(sektionen, warLeer) === NEU_LADEN;
      } catch (e) {
        fehler = e;
      }
    }
    if (neuLaden) {
      // Warenkorbseite aus dem leeren Zustand zurück: Ereignisse wie sonst, dann Merker und neu laden.
      // Fokus (H1) und Ansage (Kopf-Region) setzt merkerEinloesen nach dem Laden. Einen Fokus gibt es nur
      // nach einer Aktion in der Ansicht (etwa „Wieder hineinlegen“), nicht beim stillen Nachladen.
      senden('rs:warenkorb:geaendert', { anzahl: Number(neu.item_count) || 0, gesamt: Number(neu.total_price) || 0, korb: neu, quelle: 'warenkorb' });
      if (versandFreiGeworden(vorher, neu)) senden('rs:versand:frei', { gesamt: Number(neu.total_price) || 0 });
      merkerSchreiben({ fokus: !!i.ansicht, tastatur, ansage: i.leise ? '' : ansageText(vorher, neu, i) });
      window.location.reload();
      return;
    }
    const R = await preise();
    const ergebnis = kartenRechnen(R, neu);
    ansichten().forEach((a) => {
      kartenZeichnen(a, ergebnis);
      versandZeichnen(a, ergebnis);
    });
    meldungenZeichnen();
    leisteBeobachten();
    if (i.ansicht && (i.fokus || !aktiv || !aktiv.isConnected || aktiv === doc.body || !i.ansicht.contains(aktiv))) {
      if (i.ansicht !== drawer || offen) fokusSetzen(i.ansicht, i.fokus);
    }
    // E-158: Balken und Tomate vom alten zum neuen Stand; rs:versand:frei erst nach der Landung im Topf. Das Popup
    // (versandSpaeter) spielt die Landung selbst und sendet das Ereignis danach.
    const wirdFrei = versandFreiGeworden(vorher, neu);
    const bewegungen = [];
    // ohneBewegung: Hinzufügen bei geschlossener Schublade, die Bewegung läuft nach dem Öffnen (versandNachOeffnen)
    if (!i.ohneBewegung && vorher && Number(vorher.total_price) !== Number(neu.total_price)) {
      ansichten().forEach((a) => {
        const box = a.querySelector('[data-rs-wk-versand]');
        if (box) bewegungen.push(versandBewegen(box, anteilVon(vorher), anteilVon(neu), { wirdFrei }));
      });
    }
    senden('rs:warenkorb:geaendert', { anzahl: Number(neu.item_count) || 0, gesamt: Number(neu.total_price) || 0, korb: neu, quelle: 'warenkorb' });
    if (wirdFrei && !i.versandSpaeter) Promise.all(bewegungen).then(() => senden('rs:versand:frei', { gesamt: Number(neu.total_price) || 0 }));
    if (!i.leise) sprich(ansageText(vorher, neu, i));
    if (fehler) throw fehler;
  }

  // Sections holen; ein Fehler kommt als Wert zurück, damit der echte Stand trotzdem angewendet wird
  async function sektionenOderFehler() {
    try {
      return { s: await holeSektionen(), fehler: null };
    } catch (e) {
      return { s: null, fehler: e };
    }
  }

  // GET /cart.js, Bambus-Regel, Sections holen und einsetzen
  async function nachladen(info) {
    const i = info || {};
    let k = await holeKorb();
    const raus = bambusOhnePfanne(k);
    if (raus.length) {
      for (const z of raus) {
        try {
          const r = await post(D.routen.change, { id: z.key, quantity: 0 });
          if (r.ok && r.json) k = r.json;
        } catch (e) {
          /* der nächste GET zeigt den echten Stand */
        }
      }
      k = await holeKorb();
      const rueck = hinweise.find((h) => h.rueck);
      if (rueck) rueck.rueck = rueck.rueck.concat(raus.map((z) => ({ id: z.variant_id, quantity: z.quantity })));
      hinweise.push({ text: T.bambus_raus });
      i.bambusRaus = true;
    }
    const { s, fehler } = await sektionenOderFehler();
    await anwenden(k, s, i);
    if (fehler) throw fehler;
    return k;
  }

  // Ladezeit-Runde 03.10.2026 (B4): Nach erfolgreichem change.js oder update.js gilt die Antwort als Warenkorb, die
  // Sections kommen aus derselben Antwort, ohne GET /cart.js. Fehlt der Warenkorb in der Antwort oder meldet die
  // Bambus-Regel etwas, gilt der alte Weg (nachladen). Fehlen nur Sections, holt ein GET sie nach, nie ein zweiter POST.
  async function uebernehmen(json, ids, info) {
    const t = antwortTeilen(json, ids);
    if (!t.korb || bambusOhnePfanne(t.korb).length) return nachladen(info);
    const geholt = t.sektionen ? { s: t.sektionen, fehler: null } : await sektionenOderFehler();
    await anwenden(t.korb, geholt.s, info || {});
    if (geholt.fehler) throw geholt.fehler;
    return t.korb;
  }

  /* ---------- Sperren während einer Aktion (Fokus bleibt stehen) ---------- */

  function sperren(el, an) {
    if (!el) return;
    if (an) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
    const knoepfe = alle('button', el);
    if (el.matches && el.matches('button')) knoepfe.push(el);
    knoepfe.forEach((b) => {
      if (an) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });
    const laedt = el.querySelector && el.querySelector('[data-rs-wk-laedt]');
    if (laedt) laedt.hidden = !an;
  }
  const gesperrt = (el) =>
    el.getAttribute('aria-disabled') === 'true' || !!(el.closest && el.closest('[aria-busy="true"]'));

  /* ---------- Aktionen ---------- */

  function mengeKlick(knopf, art) {
    const pos = knopf.closest('[data-rs-wk-position]');
    if (!pos || gesperrt(knopf)) return;
    const ansicht = ansichtVon(knopf);
    const variante = pos.dataset.variante;
    const name = pos.dataset.name || '';
    const fokus = knopf.getAttribute('data-rs-fokus');
    sperren(pos, true);
    einreihen(async () => {
      fehlerLeeren();
      const z = korb && Array.isArray(korb.items) ? korb.items.find((i) => String(i.variant_id) === variante) : null;
      if (!z) {
        await nachladen({ art: 'stand', ansicht, leise: true });
        return;
      }
      const neu = art === 'plus' ? z.quantity + 1 : art === 'minus' ? z.quantity - 1 : 0;
      const weg = neu <= 0;
      const vorherHinweise = hinweise;
      hinweise = weg ? [{ text: fuellen(T.entfernt, { produkt: mitKomma(name) }), rueck: [{ id: z.variant_id, quantity: z.quantity }] }] : [];
      // Ladezeit-Runde 03.10.2026 (B4): die Sections im selben Aufruf (Bundled Section Rendering)
      const a = mitSektionen({ id: z.key, quantity: Math.max(0, neu) });
      let r;
      try {
        r = await post(D.routen.change, a.body);
      } catch (e) {
        hinweise = vorherHinweise;
        meldungenZeichnen();
        throw e;
      }
      if (!r.ok) {
        // 400 oder 422: den Aufruf nie wiederholen, nur GET /cart.js plus Sections
        hinweise = [];
        await nachladen({ art: 'stand', ansicht, fokus, leise: true });
        fehlerZeigen(r.status === 422 ? T.fehler_menge : weg ? T.fehler_entfernen : T.fehler_sonst);
        return;
      }
      await uebernehmen(r.json, a.ids, { art: weg ? 'entfernt' : 'menge', name, variante, ansicht, fokus: weg ? 'rueck' : fokus });
    })
      .catch(fehlerAllgemein)
      .finally(() => sperren(pos, false));
  }

  function hinzufuegen(knopf, posten, auswahl, sperrEl) {
    const ansicht = ansichtVon(knopf);
    sperren(sperrEl, true);
    einreihen(async () => {
      fehlerLeeren();
      const r = await post(D.routen.add, { items: posten.map((p) => ({ id: Number(p.id), quantity: Number(p.quantity) || 1 })) });
      if (!r.ok) {
        await nachladen({ art: 'stand', ansicht, leise: true });
        fehlerZeigen(r.status === 422 ? T.fehler_menge : T.fehler_dazulegen);
        return;
      }
      hinweise = [];
      senden('rs:warenkorb:hinzugefuegt', { landung: null, quelle: 'warenkorb', antwort: r.json });
      await nachladen({ art: 'hinzu', auswahl, ansicht, fokus: 'titel' });
    })
      .catch(fehlerAllgemein)
      .finally(() => sperren(sperrEl, false));
  }

  // Karte Bambus-Küchenhelferset: legt hinzu (seit Duo 20 % (01.10.2026) tauschen alle Pfannen-Karten, tauschKlick)
  function dazuKlick(knopf) {
    if (gesperrt(knopf) || !knopf.dataset.id) return;
    if (knopf.dataset.farbe) zuletztFarbe = knopf.dataset.farbe;
    hinzufuegen(knopf, [{ id: knopf.dataset.id, quantity: 1 }], auswahlName(knopf.dataset.id), knopf.closest('.rs-wk-karte') || knopf);
  }

  function rueckKlick(knopf) {
    const h = hinweise.find((x) => x.rueck);
    if (!h || gesperrt(knopf)) return;
    const posten = h.rueck.slice();
    const auswahl = posten
      .map((p) => (p.quantity > 1 ? p.quantity + ' × ' : '') + auswahlName(p.id))
      .filter(Boolean)
      .join(' und ');
    hinzufuegen(knopf, posten, auswahl, knopf);
  }

  /*
   * Duo 20 % (01.10.2026): Ablauf eines Tauschs als reiner Kern, ohne DOM und ohne Texte (geprüft mit Schein-Netz in
   * tools/relaunch/rs-duo-warenkorb.test.mjs). Für alle Karten, die tauschen: „Zweite Pfanne dazu“ und „Als Pfannen-Duo
   * nehmen“ (Ziel ist ein Pfannen-Duo) und den Set-Tausch (02 Abschnitt 8).
   *   k       { neuId, entfernen: [{ id, weniger }] }
   *   vorher  Warenkorb vor dem Tausch (/cart.js); fehlt er, holt der Ablauf ihn zuerst. tauschKlick gibt immer null
   *           (Prüfung Warenkorb): Nur ein frischer Stand aus der Warteschlange zählt, mit einem veralteten (zweiter Tab,
   *           ein „+“ davor) nähme der Schritt bei 422 ein Pfannen-Duo heraus, das nicht von diesem Tausch stammt.
   *   netz    { add(items), change(key, menge), korb() }: add und change geben { ok, status, json }, korb den Warenkorb
   * 1. add.js mit dem neuen Artikel, Menge 1. Scheitert das, ist nichts geändert: 'fehler'. Bei 422 (Bestand: ein
   *    Pfannen-Duo teilt sich den Bestand mit den Einzelpfannen im Warenkorb) liest der Ablauf den Warenkorb neu und nimmt
   *    heraus, was Shopify trotzdem hineingelegt hat (bei knappem Bestand legt es einen Teil hinein, Messung M1):
   *    'bestand', gelingt das nicht, 'unklar'.
   * 2. Warenkorb neu holen. 3. Je Eintrag „weniger“ Stück herausnehmen, über alle Zeilen der Variante, der Schlüssel immer
   *    aus der letzten Antwort (eine Variante kann in zwei Zeilen stehen).
   * 4. Scheitert Schritt 2 oder 3, liegt der neue Artikel schon im Warenkorb: 'mitte'. Sonst 'ok'.
   * Rückgabe { ergebnis, korb }: korb ist der letzte bekannte Warenkorb oder null.
   */
  async function tauschAblauf(k, vorher, netz) {
    const zeilenVon = (korb, id) => ((korb && korb.items) || []).filter((i) => String(i.variant_id) === String(id));
    const mengeVon = (korb, id) => zeilenVon(korb, id).reduce((t, i) => t + (Number(i.quantity) || 0), 0);
    // n Stück einer Variante herausnehmen, Zeile für Zeile; gibt den letzten Warenkorb zurück, bei einem Fehler null
    async function abbauen(korb, id, n) {
      let aktuell = korb;
      let rest = n;
      while (rest > 0) {
        const z = zeilenVon(aktuell, id).find((i) => Number(i.quantity) > 0);
        if (!z) return aktuell;
        const weg = Math.min(rest, Number(z.quantity));
        let r;
        try {
          r = await netz.change(z.key, Number(z.quantity) - weg);
        } catch (x) {
          r = null;
        }
        if (!r || !r.ok || !r.json) return null;
        aktuell = r.json;
        rest -= weg;
      }
      return aktuell;
    }
    let basis = vorher || null;
    if (!basis) {
      try {
        basis = await netz.korb();
      } catch (x) {
        basis = null;
      }
    }
    const vorherMenge = basis ? mengeVon(basis, k.neuId) : null;
    let r;
    try {
      r = await netz.add([{ id: Number(k.neuId), quantity: 1 }]);
    } catch (x) {
      r = null;
    }
    if (!r || !r.ok) {
      if (!r || r.status !== 422) return { ergebnis: 'fehler', korb: null };
      let korb;
      try {
        korb = await netz.korb();
      } catch (x) {
        return { ergebnis: 'unklar', korb: null };
      }
      const zuviel = vorherMenge === null ? 0 : mengeVon(korb, k.neuId) - vorherMenge;
      if (zuviel > 0) {
        const danach = await abbauen(korb, k.neuId, zuviel);
        if (!danach) return { ergebnis: 'unklar', korb };
        korb = danach;
      }
      return { ergebnis: 'bestand', korb };
    }
    let aktuell;
    try {
      aktuell = await netz.korb();
    } catch (x) {
      return { ergebnis: 'mitte', korb: null };
    }
    for (const e of k.entfernen || []) {
      const danach = await abbauen(aktuell, e.id, Number(e.weniger) || 0);
      if (!danach) return { ergebnis: 'mitte', korb: aktuell };
      aktuell = danach;
    }
    return { ergebnis: 'ok', korb: aktuell };
  }

  // Texte je Tausch: „Zweite Pfanne dazu“, „Als Pfannen-Duo nehmen“, Set-Tausch aus zwei Pfannen oder dem Pfannen-Duo.
  // Prüfung Texte B1 (02.10.2026): Fehler mittendrin beim Pfannen-Duo-Tausch mit eigenem Text (duo_fehler_mitte_paar),
  // denn scheitert schon das erste change.js, liegen noch beide Einzelpfannen im Warenkorb; ohne ihn duo_fehler_mitte.
  function tauschTexte(k) {
    if (k.art === 'zweite') {
      return { ok: T.zweite_ok, fehler: T.zweite_fehler, bestand: T.zweite_fehler_bestand, mitte: T.duo_fehler_mitte };
    }
    if (k.art === 'duo') {
      return { ok: T.duo_ok, fehler: T.tausch_fehler, bestand: T.duo_fehler_bestand, mitte: T.duo_fehler_mitte_paar || T.duo_fehler_mitte };
    }
    return {
      ok: T.tausch_ok,
      fehler: T.tausch_fehler,
      bestand: T.tausch_fehler_bestand,
      mitte: k.ausDuo ? T.tausch_fehler_mitte_duo : T.tausch_fehler_mitte
    };
  }

  // Tausch auf Klick (02 Abschnitt 8; Duo 20 % (01.10.2026) auch die Duo-Karten). Den Ablauf führt tauschAblauf, hier
  // nur Sperren, Ladetext, Hinweis, Ansage und Neuzeichnen. Lehnt Shopify wegen Bestand ab (422), steht ein eigener Text
  // ohne Bitte um einen neuen Versuch, und die Karte bleibt bis zum Neuladen weg (Gegenprüfung H2).
  function tauschKlick(knopf) {
    const k = kartenDaten.get(knopf);
    if (!k || gesperrt(knopf)) return;
    const ansicht = ansichtVon(knopf);
    const karte = knopf.closest('.rs-wk-karte') || knopf;
    const farbe = (k.farbe && D.farben && D.farben[k.farbe]) || '';
    const texte = tauschTexte(k);
    // Ladetext nur bei Knöpfen ohne eigene Felder; die Größenknöpfe der Karte „Zweite Pfanne dazu“ sperrt sperren(karte)
    const mitLadetext = !knopf.querySelector('[data-feld]');
    const knopfText = knopf.textContent;
    if (mitLadetext) knopf.textContent = T.tausch_laedt;
    sperren(karte, true);
    einreihen(async () => {
      fehlerLeeren();
      hinweise = [];
      // Duo 20 % (01.10.2026, Prüfung Warenkorb): Stand für Ansage und Versandbalken erst hier, nach allen früheren
      // Aktionen der Warteschlange. Den Ausgangsstand für add.js holt tauschAblauf selbst frisch (null), siehe dort.
      const vorher = korb;
      const erg = await tauschAblauf(k, null, {
        add: (items) => post(D.routen.add, { items }),
        change: (key, menge) => post(D.routen.change, { id: key, quantity: menge }),
        korb: holeKorb
      });
      // 'unklar' gibt es nur nach 422 (Bestand): auch dann bleibt die Karte bis zum Neuladen weg
      if (erg.ergebnis === 'bestand' || erg.ergebnis === 'unklar') gesperrteZiele.add(String(k.neuId));
      if ((erg.ergebnis === 'ok' || erg.ergebnis === 'mitte') && k.farbe) zuletztFarbe = k.farbe;
      if (erg.ergebnis === 'ok') {
        const okText = fuellen(texte.ok || T.tausch_ok, { farbe });
        hinweise = [{ text: okText }];
        await nachladen({ art: 'tausch', okText, farbe, ansicht, fokus: 'titel', vorher });
        return;
      }
      if (erg.ergebnis === 'mitte') {
        await nachladen({ art: 'stand', farbe, ansicht, fokus: 'titel', vorher });
        fehlerZeigen(fuellen(texte.mitte || T.tausch_fehler_mitte, { farbe }));
        return;
      }
      await nachladen({ art: 'stand', ansicht, leise: true }).catch(() => null);
      let text = texte.fehler;
      if (erg.ergebnis === 'bestand') text = texte.bestand || texte.fehler;
      else if (erg.ergebnis === 'unklar') text = T.fehler_sonst;
      fehlerZeigen(fuellen(text || T.tausch_fehler, { farbe }));
    })
      .catch(fehlerAllgemein)
      .finally(() => {
        if (mitLadetext && knopf.isConnected) knopf.textContent = knopfText;
        sperren(karte, false);
      });
  }

  function zitatUmschalten(knopf) {
    const text = doc.getElementById(knopf.getAttribute('aria-controls'));
    if (!text) return;
    const auf = text.classList.toggle('ist-kurz') === false;
    knopf.setAttribute('aria-expanded', String(auf));
    knopf.textContent = auf ? knopf.dataset.weniger : knopf.dataset.mehr;
  }

  /* ---------- Rabattcode (04 A5.10, E-62); seit 09.10.2026 auch in der Schublade (ändert E-21) ---------- */

  function codesVon(k) {
    if (!k) return [];
    if (Array.isArray(k.discount_codes)) return k.discount_codes.filter((c) => c && c.applicable).map((c) => String(c.code));
    const liste = [];
    (k.cart_level_discount_applications || []).forEach((a) => {
      if (a && a.type === 'discount_code' && a.title) liste.push(String(a.title));
    });
    (k.items || []).forEach((i) =>
      (i.line_level_discount_allocations || []).forEach((al) => {
        const a = al && al.discount_application;
        if (a && a.type === 'discount_code' && a.title && liste.indexOf(String(a.title)) < 0) liste.push(String(a.title));
      })
    );
    return liste;
  }
  const gleich = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();

  function codeEinloesen(form) {
    const eingabe = form.querySelector('input[name="discount"]');
    const code = ((eingabe && eingabe.value) || '').trim();
    if (!code) {
      if (eingabe) eingabe.focus();
      return;
    }
    // 09.10.2026: in der Ansicht, in der das Formular steht (Schublade oder Warenkorbseite)
    const ansicht = ansichtVon(form) || seite;
    const TS = jsonAus(form.closest('details') || ansicht, 'script[data-rs-wk-code-texte]') || jsonAus(ansicht, 'script[data-rs-wk-seite-texte]') || {};
    const ok = form.querySelector('[data-rs-wk-code-ok]');
    const fb = form.querySelector('[data-rs-wk-code-fehler]');
    if (ok) ok.textContent = '';
    fehlerIn(fb, '');
    sperren(form, true);
    return einreihen(async () => {
      const bestehend = codesVon(korb);
      if (!bestehend.some((c) => gleich(c, code))) {
        // Ladezeit-Runde 03.10.2026 (B4): die Sections im selben Aufruf; gilt der Code, ist die Antwort der Warenkorb
        const a = mitSektionen({ discount: bestehend.concat(code).join(',') });
        const r = await post(D.routen.update, a.body);
        const eintrag = r.json && Array.isArray(r.json.discount_codes) ? r.json.discount_codes.find((c) => gleich(c.code, code)) : null;
        if (!r.ok || !eintrag || !eintrag.applicable) {
          // Nicht anwendbaren Code wieder herausnehmen, damit er nicht still im Warenkorb bleibt; dessen Antwort ist
          // der Warenkorb. Nach 400 oder 422 kein zweiter Aufruf, nur GET /cart.js plus Sections.
          const b = mitSektionen({ discount: bestehend.join(',') });
          const weg = r.ok ? await post(D.routen.update, b.body).catch(() => null) : null;
          if (weg && weg.ok) await uebernehmen(weg.json, b.ids, { art: 'stand', ansicht, leise: true });
          else await nachladen({ art: 'stand', ansicht, leise: true });
          const fb2 = ansicht && ansicht.querySelector('[data-rs-wk-code-fehler]');
          fehlerIn(fb2, TS.code_fehler || T.fehler_sonst);
          const e2 = ansicht && ansicht.querySelector('input[name="discount"]');
          if (e2) e2.setAttribute('aria-invalid', 'true');
          return;
        }
        await uebernehmen(r.json, a.ids, { art: 'stand', ansicht, leise: true });
      } else {
        await nachladen({ art: 'stand', ansicht, leise: true });
      }
      const e3 = ansicht && ansicht.querySelector('input[name="discount"]');
      if (e3) {
        e3.value = '';
        e3.removeAttribute('aria-invalid');
      }
      const ok2 = ansicht && ansicht.querySelector('[data-rs-wk-code-ok]');
      if (ok2) ok2.textContent = fuellen(TS.code_ok, { code });
    })
      .catch(fehlerAllgemein)
      .finally(() => sperren(form, false));
  }

  function codeWeg(knopf) {
    const code = knopf.dataset.code;
    if (!code || gesperrt(knopf)) return;
    const ansicht = ansichtVon(knopf) || seite;
    sperren(knopf, true);
    einreihen(async () => {
      fehlerLeeren();
      const rest = codesVon(korb).filter((c) => !gleich(c, code));
      // Ladezeit-Runde 03.10.2026 (B4): die Sections im selben Aufruf; nach 400 oder 422 nur GET /cart.js plus Sections
      const a = mitSektionen({ discount: rest.join(',') });
      const r = await post(D.routen.update, a.body);
      const info = { art: 'stand', ansicht, fokus: 'code', leise: true };
      if (r.ok) await uebernehmen(r.json, a.ids, info);
      else await nachladen(info);
      const ok = ansicht && ansicht.querySelector('[data-rs-wk-code-ok]');
      if (ok) ok.textContent = '';
    })
      .catch(fehlerAllgemein)
      .finally(() => sperren(knopf, false));
  }

  /* ---------- Kasse-Leiste der Warenkorbseite (03 5.7, E-174) ----------
     Unter 990 px sichtbar, solange der Kasse-Knopf der Zusammenfassung nicht im Bild und keine Bildschirmtastatur offen
     ist. leistePruefen setzt ist-sichtbar an der Leiste und rs-wk-hat-leiste an html immer gemeinsam: Polster und
     Scroll-Abstand unten gibt es nur mit sichtbarer Leiste (Lehre E-153 A2). Ihre Höhe geht als --rs-wk-leiste-h an
     html (ResizeObserver, auch nach Drehen und Größenwechsel). Beim Neuzeichnen nach einer Änderung bleiben Beobachter
     und Zustand, solange Leiste und Knopf dieselben Knoten sind; sonst sprang die Seite nach jeder Mengenänderung. */

  let leistenBeobachter = null;
  let leistenHoehe = null;
  let beobLeiste = null;
  let beobKnopf = null;
  let kasseImBild = true;

  function tastaturOffen() {
    const a = doc.activeElement;
    if (a && a.matches && a.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]')) return true;
    const vv = window.visualViewport;
    return !!(vv && vv.height < window.innerHeight * 0.7);
  }

  // Ladezeit-Runde 03.10.2026 (B7): --rs-wk-leiste-h bleibt an html (Polster und scroll-padding-bottom in
  // rs-warenkorb.css), wird aber nur geschrieben, wenn sich der Wert ändert (Muster K17): jede Änderung einer vererbten
  // Variable an html zwingt die ganze Seite zu einer Stilrechnung. hoehe: schon gelesene Höhe, sonst wird gemessen.
  function leisteHoeheSetzen(leiste, hoehe) {
    const wert = (hoehe !== undefined ? hoehe : leiste ? leiste.offsetHeight : 0) + 'px';
    if (html.style.getPropertyValue('--rs-wk-leiste-h') !== wert) html.style.setProperty('--rs-wk-leiste-h', wert);
  }

  function leistePruefen() {
    const leiste = seite && seite.querySelector('[data-rs-wk-leiste]');
    if (!leiste || leiste !== beobLeiste) return;
    let zeigen = !kasseImBild && !tastaturOffen();
    // Liegt der Fokus in der Leiste selbst, bleibt sie stehen
    if (!zeigen && leiste.contains(doc.activeElement)) zeigen = true;
    if (leiste.classList.contains('ist-sichtbar') === zeigen) return;
    // B7: die Höhe vor dem Umschalten lesen; ist-sichtbar ändert nur transform und visibility, nicht die Höhe. Danach
    // misst allein der Fokus-Abgleich, und das bei Tastaturfokus.
    const hoehe = zeigen ? leiste.offsetHeight : 0;
    leiste.classList.toggle('ist-sichtbar', zeigen);
    html.classList.toggle('rs-wk-hat-leiste', zeigen);
    if (!zeigen) return;
    leisteHoeheSetzen(leiste, hoehe);
    // WCAG 2.4.11 (wie rs-buybox.js): Tastaturfokus nicht unter der eben eingeblendeten Leiste lassen
    const a = doc.activeElement;
    if (a && a !== doc.body && !leiste.contains(a) && a.matches && a.matches(':focus-visible')) {
      const dy = a.getBoundingClientRect().bottom - (window.innerHeight - hoehe - 8);
      if (dy > 0) window.scrollBy(0, dy);
    }
  }

  function leisteBeobachten() {
    if (!seite) return;
    const leiste = seite.querySelector('[data-rs-wk-leiste]');
    const knopf = seite.querySelector('[data-rs-wk-kasse-haupt]');
    if (leiste && knopf && leiste === beobLeiste && knopf === beobKnopf) {
      leisteHoeheSetzen(leiste);
      leistePruefen();
      return;
    }
    if (leistenBeobachter) leistenBeobachter.disconnect();
    if (leistenHoehe) leistenHoehe.disconnect();
    leistenBeobachter = null;
    leistenHoehe = null;
    beobLeiste = null;
    beobKnopf = null;
    kasseImBild = true;
    html.classList.remove('rs-wk-hat-leiste');
    html.style.removeProperty('--rs-wk-leiste-h');
    if (!leiste || !knopf || !('IntersectionObserver' in window)) return;
    beobLeiste = leiste;
    beobKnopf = knopf;
    leistenBeobachter = new IntersectionObserver((eintraege) => {
      kasseImBild = eintraege[eintraege.length - 1].isIntersecting;
      leistePruefen();
    });
    leistenBeobachter.observe(knopf);
    if ('ResizeObserver' in window) {
      leistenHoehe = new ResizeObserver(() => leisteHoeheSetzen(leiste));
      leistenHoehe.observe(leiste);
    }
  }

  // Tastatur auf und zu: einmal registriert, je Bild gebündelt (focusout kommt vor focusin, sonst flackerte die Leiste)
  if (seite) {
    let leisteWartet = false;
    const leisteBald = () => {
      if (leisteWartet) return;
      leisteWartet = true;
      window.requestAnimationFrame(() => {
        leisteWartet = false;
        leistePruefen();
      });
    };
    doc.addEventListener('focusin', leisteBald);
    doc.addEventListener('focusout', leisteBald);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', leisteBald);
  }

  /* ---------- Zusammenfassung der Warenkorbseite (E-158) ----------
     Ab 990 px klebt sie neben den Positionen. Ihre Höhe geht als --rs-wk-summe-h an die Spalte; das CSS begrenzt top
     so, dass eine hohe Zusammenfassung mitläuft, bis ihr Ende im Bild ist (Prüfung E-158: vorher klebte sie nur, wenn
     sie ganz ins Fenster passte, auf üblichen Bildschirmen also nie). Shrines Kopf blendet sich beim Hochscrollen ein (on-scroll-up); seine
     sichtbare Unterkante geht als --rs-wk-kopf an die Seite, damit er die Zusammenfassung nicht verdeckt (gleich wie
     --rs-kb-kopf der Kaufbühne): nach jedem Scroll-Ereignis 450 ms lang je Bild gemessen. */
  const breitMq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  const kopfSektion = doc.querySelector('.section-header');
  function summeKleben() {
    const sp = seite && seite.querySelector('[data-rs-wk-summe-spalte]');
    if (!sp) return;
    const breit = !breitMq || breitMq.matches;
    // Wischliste der Bewertungen: Tab-Halt nur, solange sie seitlich läuft (Safari macht Scrollbereiche nicht selbst
    // fokussierbar, WCAG 2.1.1), auf allen Breiten
    const bew = seite.querySelector('[data-rs-wk-bew-liste]');
    // Ladezeit-Runde 03.10.2026 (B7): erst alles lesen, dann schreiben, und nur, was sich ändert. Früher las es die
    // Höhe, schrieb Variable und Klasse und las danach die Wischliste: ein zweites erzwungenes Layout bei jedem Aufruf.
    // Die Höhe braucht nur das Kleben ab 990 px (rs-warenkorb.css), darunter wird sie nicht gemessen.
    const hoehe = breit ? sp.offsetHeight + 'px' : '';
    const seitlich = !!bew && bew.scrollWidth > bew.clientWidth + 1;
    if (hoehe && sp.style.getPropertyValue('--rs-wk-summe-h') !== hoehe) sp.style.setProperty('--rs-wk-summe-h', hoehe);
    sp.classList.toggle('ist-klebend', breit);
    if (bew && bew.hasAttribute('tabindex') !== seitlich) {
      if (seitlich) bew.setAttribute('tabindex', '0');
      else bew.removeAttribute('tabindex');
    }
  }
  if (seite) {
    let kopfWert = null;
    let kopfBis = 0;
    let kopfLaeuft = false;
    const kopfMessen = () => {
      if (!kopfSektion || (breitMq && !breitMq.matches)) return;
      const u = Math.max(0, Math.round(kopfSektion.getBoundingClientRect().bottom));
      if (u === kopfWert) return;
      kopfWert = u;
      seite.style.setProperty('--rs-wk-kopf', u + 'px');
    };
    const kopfSchleife = () => {
      kopfMessen();
      if (performance.now() < kopfBis) window.requestAnimationFrame(kopfSchleife);
      else kopfLaeuft = false;
    };
    const kopfAnstossen = () => {
      kopfBis = performance.now() + 450;
      if (!kopfLaeuft) {
        kopfLaeuft = true;
        window.requestAnimationFrame(kopfSchleife);
      }
    };
    window.addEventListener('scroll', kopfAnstossen, { passive: true });
    window.addEventListener('resize', () => {
      kopfAnstossen();
      summeKleben();
    }, { passive: true });
    kopfMessen();
    const sp = seite.querySelector('[data-rs-wk-summe-spalte]');
    if (sp && 'ResizeObserver' in window) new ResizeObserver(summeKleben).observe(sp);
    summeKleben();
  }

  /* ---------- Express-Knöpfe der Warenkorbseite bei Bedarf (Ladezeit-Runde 03.10.2026, B5) ----------
     Mit express_spaeter (rs-warenkorb-seite.liquid) steht Shopifys ganze Ausgabe (div#dynamic-checkout-cart mit
     shopify-accelerated-checkout-cart) als <template data-rs-wk-express-knopf> im Behälter [data-rs-wk-express], davor
     ein Platzhalter. Eingesetzt wird bei Annäherung (200 px), bei der ersten Eingabe (pointerdown, keydown) oder
     spätestens im Leerlauf nach load (Frist 2 s), nie im Ereignis selbst (INP). Shopifys Skript startet die Knöpfe
     beim Einfügen; Shopify.PaymentButton.init() stößt nach, falls vorhanden. Ohne Vorlage (Schalter aus, Theme-Editor)
     geschieht nichts. Muster: rs-buybox.js, expressVorlagen (E-187).
     Prüfung nach dem Push (03.10.2026): WebKit kennt kein requestIdleCallback. Nach load wartet der Rückfall dort
     500 ms, damit die Knöpfe nicht im selben Zug wie die übrigen load-Hörer kommen (Chrome fand den Leerlauf nach load
     in der Messung nach 144 ms), weit unter der Frist von 2 s; bei Annäherung und erster Eingabe bleibt es bei 1 ms.
     Ist Shopifys Element 5 s nach dem Einsetzen nicht aufgebaut (nicht definiert oder das Exemplar nicht :defined,
     etwa weil portable-wallets nicht lud), nimmt rs-cart.js dem Behälter die Mindesthöhe (Klasse
     rs-wk-express--spaeter) und ruft Shopifys portableWalletsCleanup auf, falls es sie gibt. Sie entfernt das
     Ladebild; beim Ladefehler lief sie schon, als die Knöpfe noch in der Vorlage standen, und fand es dort nicht.
     Dazu ruft es Shopify.PaymentButton.init() ein zweites Mal auf. Das schadet nicht, bewirkt aber meist nichts:
     Shopifys Platzhalter ersetzt sich beim ersten Aufruf durch eine leere Funktion (Gegenprüfung 03.10.2026). */
  const wkLeerlauf = (fn, frist, aufschub) => {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: frist });
    else window.setTimeout(fn, aufschub || 1);
  };
  const wkExpressAnstossen = () => {
    const pb = window.Shopify && window.Shopify.PaymentButton;
    if (pb && typeof pb.init === 'function') pb.init();
  };
  // Aufgebaut: Shopify hat das Element definiert, und dieses Exemplar ist hochgestuft (:defined)
  const wkExpressAufgebaut = (el) => {
    const ce = window.customElements;
    if (!ce || typeof ce.get !== 'function' || !ce.get('shopify-accelerated-checkout-cart')) return false;
    try {
      return el.matches(':defined');
    } catch (e) {
      return true;
    }
  };
  let wkExpressFrei = false;
  let wkExpressIo = null;
  function wkExpressEinsetzen(ansicht) {
    const a = ansicht && typeof ansicht.querySelector === 'function' ? ansicht : seite;
    const ex = a && a.querySelector('[data-rs-wk-express]');
    const t = ex && ex.querySelector('template[data-rs-wk-express-knopf]');
    if (!t) return false;
    const platz = ex.querySelector('[data-rs-wk-express-platz]');
    t.replaceWith(doc.importNode(t.content, true));
    if (platz) platz.remove();
    wkExpressAnstossen();
    // Rückfall: nach 5 s nicht aufgebaut, dann Mindesthöhe frei und Shopifys Ladebild weg (das zweite init ist meist leer)
    window.setTimeout(() => {
      const el = ex.querySelector('shopify-accelerated-checkout-cart');
      if (!el || wkExpressAufgebaut(el)) return;
      wkExpressAnstossen();
      ex.classList.remove('rs-wk-express--spaeter');
      if (typeof window.portableWalletsCleanup === 'function') window.portableWalletsCleanup();
    }, 5000);
    return true;
  }
  function wkExpressFreigeben(frist, aufschub) {
    if (wkExpressFrei) return;
    wkExpressFrei = true;
    if (wkExpressIo) wkExpressIo.disconnect();
    wkLeerlauf(wkExpressEinsetzen, frist, aufschub);
  }
  function wkExpressBeobachten() {
    const ex = seite && seite.querySelector('[data-rs-wk-express]');
    if (!ex || !ex.querySelector('template[data-rs-wk-express-knopf]')) return;
    if ('IntersectionObserver' in window) {
      wkExpressIo = new IntersectionObserver((e) => {
        if (e.some((x) => x.isIntersecting)) wkExpressFreigeben(1000);
      }, { rootMargin: '0px 0px 200px 0px' });
      wkExpressIo.observe(ex);
    }
    ['pointerdown', 'keydown'].forEach((typ) => window.addEventListener(typ, () => wkExpressFreigeben(1000), { once: true, passive: true }));
    // ohne requestIdleCallback (WebKit) 500 ms nach load, sonst im Leerlauf mit Frist 2 s
    const nachLoad = () => wkExpressFreigeben(2000, 500);
    if (doc.readyState === 'complete') nachLoad();
    else window.addEventListener('load', nachLoad, { once: true });
  }

  /* ---------- EU-Mitteilung in voller Größe (04 A4.10, rs-eu-gewaehrleistung) ---------- */

  let euDialog = null;
  let euAusloeser = null;
  let euOffen = false;

  function euOeffnen(link) {
    if (!euDialog) {
      euDialog = doc.createElement('dialog');
      euDialog.className = 'rs-eu-voll';
      euDialog.setAttribute('aria-labelledby', 'rs-eu-voll-titel');
      const kopf = doc.createElement('div');
      kopf.className = 'rs-eu-voll__kopf';
      const titel = doc.createElement('p');
      titel.className = 'rs-eu-voll__titel';
      titel.id = 'rs-eu-voll-titel';
      const zu = doc.createElement('button');
      zu.type = 'button';
      zu.className = 'rs-eu-voll__zu';
      const flaeche = doc.createElement('div');
      flaeche.className = 'rs-eu-voll__flaeche';
      flaeche.tabIndex = 0;
      flaeche.setAttribute('role', 'region');
      flaeche.setAttribute('aria-labelledby', 'rs-eu-voll-titel');
      const bild = doc.createElement('img');
      bild.className = 'rs-eu-voll__bild';
      bild.width = 1654;
      bild.height = 2339;
      bild.decoding = 'async';
      flaeche.appendChild(bild);
      kopf.append(titel, zu);
      euDialog.append(kopf, flaeche);
      doc.body.appendChild(euDialog);
      zu.addEventListener('click', () => euDialog.close());
      euDialog.addEventListener('click', (e) => {
        if (e.target === euDialog) euDialog.close();
      });
      euDialog.addEventListener('close', () => {
        euOffen = false;
        if (euAusloeser && euAusloeser.isConnected) euAusloeser.focus({ preventScroll: true });
      });
    }
    euDialog.querySelector('.rs-eu-voll__titel').textContent = link.getAttribute('data-rs-eu-titel') || '';
    euDialog.querySelector('.rs-eu-voll__zu').textContent = link.getAttribute('data-rs-eu-schliessen') || '';
    const bild = euDialog.querySelector('.rs-eu-voll__bild');
    bild.alt = link.getAttribute('data-rs-eu-alt') || '';
    bild.src = link.href;
    euAusloeser = link;
    euDialog.showModal();
    euOffen = true;
    euDialog.querySelector('.rs-eu-voll__zu').focus();
  }

  /* ---------- Drawer öffnen und schließen ---------- */

  let offen = false;
  let schliesst = false;
  // Runde Seitenleiste 2: erfüllt sich, wenn die Schublade nach dem letzten Öffnen steht (versandNachOeffnen wartet darauf)
  let fahrt = Promise.resolve();
  let ausloeserEl = null;
  let naechsterFokus = null;
  const hatDialog = !!(drawer && typeof drawer.showModal === 'function');

  // Rückfall ohne <dialog> (iOS 15.0 bis 15.3, 05 Abschnitt 14): role dialog, Rest der Seite versteckt
  function ersatzModal(an) {
    if (!drawer || hatDialog) return;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    Array.from(doc.body.children).forEach((el) => {
      if (el.contains(drawer) || el.tagName === 'SCRIPT' || el === euDialog) return;
      if (an) {
        if (el.getAttribute('aria-hidden') !== 'true') {
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('data-rs-wk-versteckt', '');
        }
        if ('inert' in el) el.inert = true;
      } else if (el.hasAttribute('data-rs-wk-versteckt')) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('data-rs-wk-versteckt');
        if ('inert' in el) el.inert = false;
      }
    });
  }

  const standVon = (k) =>
    k ? k.item_count + '|' + k.total_price + '|' + (k.items || []).map((i) => i.key).join(',') : '';
  function standAngezeigt() {
    const el = drawer && drawer.querySelector('[data-rs-wk-stand]');
    return el ? el.getAttribute('data-rs-wk-stand') : '';
  }

  /* ---------- Schublade vorbereiten (09.10.2026, Runde Seitenleiste; Runde Seitenleiste 2, 10.10.2026) ----------
     Lädt rs-fragen.* (Aufklapper des Rabattcodes) und rs-versandschluss.js (Versandtag, holt /cart.js für die
     Serverzeit), nur wenn die Seite sie nicht schon hat. Seit Runde 2 nicht mehr im ersten Bild der Fahrt: beim
     Hinzufügen (während der Flug läuft), im Leerlauf nach dem Laden, wenn schon Ware im Warenkorb liegt, und vor dem
     Öffnen als Rückfall. Vertrauenskarten, Fragen und PayPal-Express stehen nicht mehr in der Schublade; seit Runde 3
     setzt es die fünf Bewertungen aus ihrer Vorlage ein (bewAnbinden). */
  let drawerVorbereitet = false;
  function nachladenSkript(url) {
    if (!url || doc.querySelector('script[src="' + url + '"]')) return;
    const el = doc.createElement('script');
    el.src = url;
    el.defer = true;
    doc.head.appendChild(el);
  }
  function nachladenBlatt(url, kennung) {
    if (!url || doc.querySelector('link[href*="' + kennung + '"]')) return;
    const el = doc.createElement('link');
    el.rel = 'stylesheet';
    el.href = url;
    doc.head.appendChild(el);
  }
  function drawerVorbereiten() {
    if (!drawer) return;
    // Runde Seitenleiste 3 (10.10.2026): Die Bewertungen stehen als Vorlage im HTML (snippets/rs-wk-bewertungen.liquid)
    // und kommen hier hinein, solange die Ebene zu ist (beim Hinzufügen, im Leerlauf, vor showModal). Ein Fehler lässt
    // nur sie weg, der Warenkorb bleibt bedienbar.
    const bewVorlage = drawer.querySelector('template[data-rs-wk-bew-vorlage]');
    if (bewVorlage) {
      try {
        bewVorlage.replaceWith(doc.importNode(bewVorlage.content, true));
        bewAnbinden(drawer.querySelector('[data-rs-wk-bew]'));
      } catch (e) {
        /* ohne Bewertungen weiter */
      }
    }
    if (drawerVorbereitet) return;
    drawerVorbereitet = true;
    if (drawer.querySelector('details.rs-frage')) {
      nachladenBlatt(D.fragenCss, 'rs-fragen.css');
      if (!doc.querySelector('script[src*="rs-fragen.js"]')) nachladenSkript(D.fragenJs);
    }
    if (drawer.querySelector('[data-rs-versandschluss]') && !window.RSVersandschluss) nachladenSkript(D.versandschlussJs);
  }

  // Runde Seitenleiste 2: Die Bilder der Positionen stehen lazy in der zugeklappten Ebene und luden erst während der
  // Fahrt; sie erschienen sichtbar später (Video 10.10.2026). Nach jedem Einsetzen, im Leerlauf und vor dem Öffnen laden
  // sie deshalb sofort, es sind wenige kleine Bilder (96 px). Beim Hinzufügen wärmt bilderWaermen sie schon vor der
  // Landung des Flugs aus dem frisch geholten HTML vor.
  function bilderVorladen() {
    if (!drawer) return;
    alle('.rs-wk-position__bild img[loading="lazy"]', drawer).forEach((b) => {
      b.loading = 'eager';
    });
  }
  function bilderWaermen(sektionen) {
    const roh = drawer && sektionen && sektionen[idDrawer];
    if (!roh) return;
    try {
      const neu = new DOMParser().parseFromString(roh, 'text/html');
      alle('.rs-wk-position__bild img', neu).forEach((b) => {
        const bild = new Image();
        if (b.getAttribute('sizes')) bild.sizes = b.getAttribute('sizes');
        if (b.getAttribute('srcset')) bild.srcset = b.getAttribute('srcset');
        if (b.getAttribute('src')) bild.src = b.getAttribute('src');
      });
    } catch (e) {
      /* nur Vorwärmen, ohne Folgen */
    }
  }

  /* ---------- Bewertungen in der Schublade (Runde Seitenleiste 3, 10.10.2026) ----------
     Denny: „ein zentral und dann kann man halt nach rechts und nach links gehen“. Die Liste rastet mittig ein (CSS); die
     Pfeile und die Pfeiltasten blättern um eine Karte, an den Enden geht es von vorn weiter (wie rs-bewertungen.js), die
     Ansage nennt die Karte. Lange Texte stehen gekürzt (Klasse ist-kurz, 6 Zeilen); „Ganze Bewertung lesen“ erscheint
     nur, wo wirklich etwas abgeschnitten ist, und schaltet über zitatUmschalten. Gemessen wird erst in der Nähe
     (IntersectionObserver am Rumpf), nie in der Fahrt. Läuft eine offene Bewertung beim Blättern zu mehr als der Hälfte
     aus dem Bild, klappt sie zu; dann gilt wieder die gemeinsame Höhe der Karten (wie E-172 auf der Kaufseite). */
  function bewAnbinden(bew) {
    const band = bew && bew.querySelector('[data-rs-wk-bew-band]');
    if (!band) return;
    alle('.rs-kb-bew__text', band).forEach((text, i) => {
      text.id = 'rs-wk-bew-text-' + (i + 1);
      text.classList.add('ist-kurz');
      const knopf = doc.createElement('button');
      knopf.type = 'button';
      knopf.className = 'rs-wk-bew__mehr';
      knopf.setAttribute('data-rs-wk-aktion', 'zitat');
      knopf.setAttribute('aria-expanded', 'false');
      knopf.setAttribute('aria-controls', text.id);
      knopf.dataset.mehr = bew.getAttribute('data-text-mehr') || '';
      knopf.dataset.weniger = bew.getAttribute('data-text-weniger') || '';
      knopf.textContent = knopf.dataset.mehr;
      knopf.hidden = true;
      text.after(knopf);
    });
    const pruefen = () =>
      alle('.rs-wk-bew__mehr', band).forEach((knopf) => {
        const text = knopf.previousElementSibling;
        if (text) knopf.hidden = text.classList.contains('ist-kurz') && !(text.scrollHeight > text.clientHeight + 2);
      });
    let nah = !('IntersectionObserver' in window);
    let ausstehend = true;
    const messen = () => {
      if (!nah) {
        ausstehend = true;
        return;
      }
      ausstehend = false;
      pruefen();
    };
    const spaeter = () => {
      ausstehend = true;
      messen();
    };
    if (!nah) {
      new IntersectionObserver(
        (eintraege) => {
          nah = eintraege[eintraege.length - 1].isIntersecting;
          if (nah && ausstehend) messen();
        },
        { root: drawer.querySelector('.rs-wk-drawer__rumpf'), rootMargin: '25% 0px' }
      ).observe(bew);
    }
    let uhr = 0;
    window.addEventListener('resize', () => {
      window.clearTimeout(uhr);
      uhr = window.setTimeout(spaeter, 150);
    });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(spaeter);
    messen();
    let zuUhr = 0;
    band.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(zuUhr);
        zuUhr = window.setTimeout(() => {
          const b = band.getBoundingClientRect();
          alle('.rs-kb-bew__text:not(.ist-kurz)', band).forEach((text) => {
            const karte = text.closest('.rs-kb-bew__karte');
            const knopf = text.nextElementSibling;
            if (!karte || !knopf || !knopf.classList.contains('rs-wk-bew__mehr')) return;
            const r = karte.getBoundingClientRect();
            if (Math.max(0, Math.min(r.right, b.right) - Math.max(r.left, b.left)) < r.width / 2) zitatUmschalten(knopf);
          });
        }, 150);
      },
      { passive: true }
    );
  }
  // Eine Karte weiter (1) oder zurück (-1), an den Enden von vorn; gemessen wird nur beim Blättern
  function bewBlaettern(el, richtung) {
    const bew = el.closest('[data-rs-wk-bew]');
    const band = bew && bew.querySelector('[data-rs-wk-bew-band]');
    const n = band ? band.children.length : 0;
    if (!n) return;
    const stil = window.getComputedStyle(band);
    const schritt = band.children[0].getBoundingClientRect().width + (parseFloat(stil.columnGap || stil.gap) || 0);
    if (!(schritt > 0)) return;
    const stelle = Math.min(n - 1, Math.max(0, Math.round(band.scrollLeft / schritt)));
    const ziel = (stelle + richtung + n) % n;
    if (typeof band.scrollTo === 'function') band.scrollTo({ left: ziel * schritt, behavior: ruhig() ? 'auto' : 'smooth' });
    else band.scrollLeft = ziel * schritt;
    sprich(fuellen(T.bew_ansage, { n: ziel + 1, gesamt: n }));
  }
  // Rollt den Rumpf der offenen Schublade, bis el ganz zu sehen ist (8 px Luft). Kein scrollIntoView: das rollte auch
  // die gesperrte Seite dahinter.
  function imRumpfZeigen(el) {
    const rumpf = el && offen && drawer ? drawer.querySelector('.rs-wk-drawer__rumpf') : null;
    if (!rumpf || !rumpf.contains(el)) return;
    const mehr = el.getBoundingClientRect().bottom + 8 - rumpf.getBoundingClientRect().bottom;
    if (mehr <= 0) return;
    if (typeof rumpf.scrollBy === 'function') rumpf.scrollBy({ top: mehr, behavior: ruhig() ? 'auto' : 'smooth' });
    else rumpf.scrollTop += mehr;
  }

  // Runde Seitenleiste 2: Ende der Fahrt der Schublade, am transitionend der Schublade selbst (Eigenschaft transform),
  // mit Frist aus dem Blatt (--rs-wk-auf, --rs-wk-zu an der Ebene) plus Polster; bei weniger Bewegung sofort.
  // Ein Abbruch (transitioncancel, etwa Schließen während der Fahrt) zählt als Ende.
  // WebKit gibt den Wert aus dem Blatt als Sekunden zurück („0.26s“), Chrome wie geschrieben („260ms“; Messung 10.10.2026)
  const fahrtMs = (name, rueck) => {
    const roh = String(window.getComputedStyle(drawer).getPropertyValue(name)).trim();
    const v = parseFloat(roh);
    if (!(v > 0)) return rueck;
    return /ms$/i.test(roh) ? v : /s$/i.test(roh) ? v * 1000 : v;
  };
  function fahrtEnde(an) {
    return new Promise((fertig) => {
      const panel = drawer && drawer.querySelector('.rs-wk-drawer');
      if (!panel || ruhig()) {
        fertig();
        return;
      }
      let frist = 0;
      const weiter = (e) => {
        if (e && e.type && (e.target !== panel || e.propertyName !== 'transform')) return;
        panel.removeEventListener('transitionend', weiter);
        panel.removeEventListener('transitioncancel', weiter);
        window.clearTimeout(frist);
        fertig();
      };
      panel.addEventListener('transitionend', weiter);
      panel.addEventListener('transitioncancel', weiter);
      frist = window.setTimeout(weiter, fahrtMs(an ? '--rs-wk-auf' : '--rs-wk-zu', an ? 380 : 260) + 150);
    });
  }
  // Ohne overflow: clip (Safari vor 16) rollt showModal die Ebene seitlich; dort setzt oeffnen den Versatz zurück
  const clipGeht = !!(window.CSS && typeof window.CSS.supports === 'function' && window.CSS.supports('overflow', 'clip'));

  // Ausnahme von 05 8.6 (Denny, 09.10.2026): „Warenkorb angesehen“ für GA4. Shopifys cart_viewed kommt nur mit dem Aufruf
  // von /cart; das Stape-App-Pixel macht daraus view_cart_stape, und daran hängt im Web-Container nur der GA4-Tag
  // view_cart (Werte aus ecommerce.value, ecommerce.currency, ecommerce.items). Jetzt schreibt jedes Öffnen der Schublade
  // mit Ware dasselbe Ereignis, vorher ecommerce leeren (GA4-Regel). Ohne Ware nichts. Die Einwilligung regelt der Container.
  function warenkorbAngesehen() {
    const k = korb;
    if (!k || !(Number(k.item_count) > 0)) return;
    const dl = (window.dataLayer = window.dataLayer || []);
    dl.push({ ecommerce: null });
    dl.push({
      event: 'view_cart_stape',
      ecommerce: {
        currency: k.currency || 'EUR',
        value: (Number(k.total_price) || 0) / 100,
        items: (k.items || []).map((i) => ({
          item_id: String(i.product_id),
          item_variant: String(i.variant_id),
          item_name: String(i.product_title || ''),
          price: (Number(i.final_price) || 0) / 100,
          quantity: Number(i.quantity) || 1
        }))
      }
    });
  }

  async function auffrischenWennNoetig() {
    const k = await holeKorb();
    if (standVon(k) !== standAngezeigt()) {
      const { s, fehler } = await sektionenOderFehler();
      await anwenden(k, s, { art: 'stand', leise: true });
      if (fehler) throw fehler;
    } else {
      korb = k;
    }
  }

  function oeffnen(optionen) {
    const o = optionen || {};
    if (!drawer || D.warenkorbseite) return false;
    if (!wkCssDa()) {
      wkCssBereit().then(() => {
        wkCssFertig = true;
        oeffnen(o);
      });
      return true;
    }
    if (offen) {
      // Runde Seitenleiste 2: ein Tipp während des Schließens holt sie zurück (schliessen fragt schliesst vor close ab)
      if (schliesst) {
        schliesst = false;
        drawer.classList.add('ist-offen');
      }
      fokusSetzen(drawer, 'titel');
      return true;
    }
    offen = true;
    schliesst = false;
    const aktiv = doc.activeElement;
    ausloeserEl = o.ausloeser || (aktiv && aktiv !== doc.body ? aktiv : null);
    // Runde Seitenleiste 2 (10.10.2026): alles Vorbereiten, solange die Ebene noch zu ist; im ersten Bild der Fahrt soll
    // nichts mehr rechnen (Messung: drei lange Bilder von 110 bis 174 ms beim ersten Öffnen nach dem Hinzufügen). Der Rumpf
    // steht schon oben, schliessen setzt ihn zurück, solange die Ebene noch steht (04 A5.1, 05 6.16).
    drawerVorbereiten();
    bilderVorladen();
    html.classList.add('rs-ohne-scroll', 'rs-warenkorb-offen');
    // Clarity (18.10.2026): Die Aufnahme spielt die Ebene ohne Top Layer ab; rs-warenkorb.css hebt sie dort per
    // [open]:not(:modal) nach oben. Die beiden Rückfälle unten öffnen auch bei echten Besuchern nicht modal, sie bekommen
    // die Marke data-rs-wk-ohne-modal, damit die Regel nur in der Wiedergabe greift (dort steht die Marke dann auch).
    drawer.removeAttribute('data-rs-wk-ohne-modal');
    if (hatDialog) {
      try {
        drawer.showModal();
      } catch (e) {
        drawer.setAttribute('data-rs-wk-ohne-modal', '');
        drawer.setAttribute('open', '');
      }
    } else {
      drawer.setAttribute('data-rs-wk-ohne-modal', '');
      drawer.setAttribute('open', '');
      ersatzModal(true);
    }
    // showModal setzt den Fokus selbst auf ein Element der Schublade und rollt dabei die Ebene seitlich, bis es zu sehen
    // ist: die noch rechts liegende Schublade stand so sofort da, die Fahrt verpuffte (Messung 10.10.2026: 332 px am Handy,
    // 440 px am Rechner, in Chrome und WebKit; Denny: „wie ein Pop-up“). overflow: clip an der Ebene verhindert das Rollen;
    // ohne clip hier zurück, bevor das erste Bild entsteht.
    if (!clipGeht) {
      drawer.scrollLeft = 0;
      drawer.scrollTop = 0;
    }
    fokusSetzen(drawer, 'titel');
    let eingefahren;
    if (ruhig()) {
      drawer.classList.add('ist-offen');
      eingefahren = Promise.resolve();
    } else {
      eingefahren = new Promise((fertig) => {
        window.requestAnimationFrame(() =>
          window.requestAnimationFrame(() => {
            if (!offen || schliesst) {
              fertig();
              return;
            }
            drawer.classList.add('ist-offen');
            fahrtEnde(true).then(fertig);
          })
        );
      });
    }
    fahrt = eingefahren;
    senden('rs:warenkorb:geoeffnet', {});
    // Erst nach der Fahrt: Kartenprüfung (misst Breiten), Tomate und „Warenkorb angesehen“ (genau einmal je Öffnen)
    eingefahren.then(() => alle('.rs-wk-karten__liste', drawer).forEach((l) => l.rsPruefen && l.rsPruefen()));
    // Beim Zeigen hüpft die Tomate zweimal (E-158, wie früher nur auf der Warenkorbseite); nach dem Hinzufügen rollt sie
    // stattdessen (versandNachOeffnen)
    if (o.huepfen !== false) {
      eingefahren.then(() =>
        window.setTimeout(() => {
          const box = offen && drawer.querySelector('[data-rs-wk-versand]');
          if (box) tomateHuepfen(box);
        }, 120)
      );
    }
    if (o.auffrischen !== false) einreihen(auffrischenWennNoetig).then(() => eingefahren).then(warenkorbAngesehen, fehlerAllgemein);
    else eingefahren.then(warenkorbAngesehen);
    return true;
  }

  // Nach dem Hinzufügen bei geschlossener Schublade: Balken und Tomate rollen nach dem Öffnen vom alten zum neuen Stand,
  // erreicht der Warenkorb die Schwelle, hoppelt sie in den Topf; rs:versand:frei erst nach der Landung (wie das Popup)
  function versandNachOeffnen(vorher, neu) {
    const wirdFrei = versandFreiGeworden(vorher, neu);
    const frei = () => {
      if (wirdFrei) senden('rs:versand:frei', { gesamt: Number(neu.total_price) || 0 });
    };
    const box = drawer && drawer.querySelector('[data-rs-wk-versand]');
    if (!box || !vorher || Number(vorher.total_price) === Number(neu.total_price)) {
      frei();
      return;
    }
    box.style.setProperty('--anteil', String(anteilVon(vorher)));
    // Runde Seitenleiste 2: rollt, sobald die Schublade steht (vorher fest nach 320 ms, mitten in der Fahrt)
    fahrt
      .then(() => versandBewegen(box, anteilVon(vorher), anteilVon(neu), { wirdFrei }))
      .then(frei, frei);
  }

  function nachSchliessen() {
    if (!offen) return;
    offen = false;
    schliesst = false;
    drawer.classList.remove('ist-offen');
    html.classList.remove('rs-ohne-scroll', 'rs-warenkorb-offen');
    ersatzModal(false);
    hinweise = [];
    meldungenZeichnen();
    fehlerLeeren();
    const ziel = naechsterFokus;
    naechsterFokus = null;
    const ausloeser = ausloeserEl;
    ausloeserEl = null;
    // Zuerst melden: rs-buybox.js blendet daraufhin die Kaufleiste wieder ein (im nächsten Frame)
    senden('rs:warenkorb:geschlossen', {});
    if (ziel) {
      if (!ziel.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(ziel.tagName)) ziel.setAttribute('tabindex', '-1');
      ziel.focus({ preventScroll: true });
      ziel.scrollIntoView({ block: 'start', behavior: ruhig() ? 'auto' : 'smooth' });
    } else {
      fokusZurueck(ausloeser);
    }
  }

  /* ---------- Fokus nach dem Schließen (05 6.16: Fokus zurück zum Auslöser) ---------- */

  // Wirklich fokussierbar und sichtbar? Die Kaufleiste ist, solange der Drawer offen war, nur
  // visibility: hidden; getClientRects() allein sieht das nicht. Chromium verweigert dann den Fokus,
  // WebKit setzt ihn und nimmt ihn beim nächsten Stil-Durchlauf wieder weg (geprüft im Nachbau).
  function fokusFaehig(el) {
    if (!el || !el.isConnected || typeof el.focus !== 'function') return false;
    if (drawer && drawer.contains(el)) return false;
    if (popup && popup.contains(el)) return false;
    if (!el.getClientRects().length) return false;
    if (el.closest('[inert], [hidden], [aria-hidden="true"]')) return false;
    if (window.getComputedStyle(el).visibility !== 'visible') return false;
    if (typeof el.checkVisibility === 'function') {
      return el.checkVisibility({ visibilityProperty: true, checkVisibilityCSS: true });
    }
    return true;
  }
  function fokusVersuchen(el, mitScroll) {
    if (!fokusFaehig(el)) return false;
    try {
      el.focus({ preventScroll: !mitScroll });
    } catch (e) {
      return false;
    }
    return doc.activeElement === el;
  }
  const topfLink = () => doc.querySelector('a.header__icon--cart');
  const buyboxKaufknopf = () => doc.querySelector('form[data-rs-buybox-form] [data-rs-kaufen]');

  // Reihenfolge: der auslösende Knopf; ist er (Kaufleiste) auch nach dem Wiedereinblenden nicht
  // sichtbar, der Kaufknopf der Buybox, zuletzt der Topf im Kopf.
  function fokusZurueck(ausloeser) {
    const kette = ausloeser ? [ausloeser, buyboxKaufknopf(), topfLink()] : [topfLink()];
    // E-178 Nachbesserung: Ist der Auslöser dauerhaft weg (etwa „Details“ der Bambus-Zeile, deren Hülle nach dem
    // Dazulegen verborgen ist; seit 13.10.2026 löst dort der Kaufknopf aus, „Details“ nur ohne ihn), gleich weiter in
    // der Kette; die Kaufleiste dagegen kommt im nächsten Frame zurück und wird unten nachgeholt.
    const weg = !!ausloeser && (!ausloeser.isConnected || !!ausloeser.closest('[hidden]'));
    if (!fokusVersuchen(kette[0]) && weg) kette.slice(1).some((el, i) => fokusVersuchen(el, i === 0));
    // Nach zwei Frames nachsehen: rs-buybox.js blendet die Kaufleiste erst im nächsten Frame wieder
    // ein. Sitzt der Fokus dann nicht auf einem der Ziele (sondern auf body, main oder im Drawer),
    // die Kette der Reihe nach versuchen.
    window.requestAnimationFrame(() =>
      window.requestAnimationFrame(() => {
        if (offen) return;
        const a = doc.activeElement;
        if (kette.indexOf(a) >= 0) return;
        // Im Popup zählt nicht: es verschwindet 300 ms nach dem Schließen, der Fokus fiele dann auf body
        const ohneZiel = !a || a === doc.body || a === doc.documentElement || a.tagName === 'MAIN' || (drawer && drawer.contains(a)) || (popup && popup.contains(a));
        if (!ohneZiel) return;
        kette.some((el, i) => fokusVersuchen(el, ausloeser && i === 1));
      })
    );
  }

  /* ---------- Warenkorb-Popup (E-158, wie live klein) ----------
     Nicht modal: keine Fokusfalle, keine Scroll-Sperre, keine Abdunklung, kein Zeitablauf. html.rs-warenkorb-offen steht,
     solange es offen ist (die Kaufleiste weicht, der Kopf-Topf köchelt nicht). Der Fokus geht beim Öffnen auf die
     Überschrift und beim Schließen zurück zum Auslöser (fokusZurueck). Kommt noch etwas dazu, während es offen ist,
     füllt es sich neu. */

  let popupOffen = false;
  let popupAusloeser = null;

  function popupOben() {
    // Unter dem Kopf, solange er zu sehen ist (er läuft beim Hochscrollen mit), sonst 16 px vom Fensterrand; in
    // niedrigen Fenstern (Handy quer, kleine Laptops) immer 16 px, damit die Knöpfe Platz haben
    const kopf = doc.querySelector('sticky-header, .header-wrapper');
    let oben = 16;
    if (kopf && window.innerHeight >= 560) {
      const r = kopf.getBoundingClientRect();
      if (r.height && r.bottom > 0) oben = Math.max(16, Math.round(r.bottom + 12));
    }
    popup.style.setProperty('--rs-wk-popup-oben', oben + 'px');
    // Shopifys Cookie-Banner liegt unten und über allem; solange er steht, rückt das Popup über ihn (Prüfung E-158)
    const banner = doc.getElementById('shopify-pc__banner');
    let belegt = 0;
    if (banner && banner.getClientRects().length && window.getComputedStyle(banner).visibility !== 'hidden') {
      const r = banner.getBoundingClientRect();
      if (r.height && r.top < window.innerHeight) belegt = Math.max(0, Math.round(window.innerHeight - r.top));
    }
    popup.style.setProperty('--rs-wk-popup-banner', belegt + 'px');
  }

  // E-178 (Runde 20, Denny: Popup am Handy oben statt unten): Shrines Kopf fährt beim Hochscrollen ein (on-scroll-up,
  // 150 ms) und läge sonst unter dem Popup (z 5 gegen 50). Solange es offen ist, misst ein passiver Scroll-Listener die
  // Kopfkante nach jedem Scroll-Ereignis 450 ms lang je Bild neu (Muster kopfMessen der Warenkorbseite); das Popup
  // rückt unter den einfahrenden Kopf und wieder hoch, wenn er geht. popupZeigen hängt ihn an, popupSchliessen ab.
  let popupFolgtBis = 0;
  let popupFolgtLaeuft = false;
  const popupFolgenSchleife = () => {
    if (!popupOffen) {
      popupFolgtLaeuft = false;
      return;
    }
    popupOben();
    if (performance.now() < popupFolgtBis) window.requestAnimationFrame(popupFolgenSchleife);
    else popupFolgtLaeuft = false;
  };
  const popupFolgen = () => {
    popupFolgtBis = performance.now() + 450;
    if (popupFolgtLaeuft) return;
    popupFolgtLaeuft = true;
    window.requestAnimationFrame(popupFolgenSchleife);
  };
  function popupFolgenAn(an) {
    if (an) window.addEventListener('scroll', popupFolgen, { passive: true });
    else window.removeEventListener('scroll', popupFolgen);
  }

  function bildVon(art, f) {
    const b = D.bilder && D.bilder[art];
    return (b && b[f]) || '';
  }

  // Bild einer Position aus add.js (fremde Produkte, Rückfall beim Pfannen-Duo)
  const bildAusPosten = (p) => {
    if (!p) return '';
    if (typeof p.image === 'string') return p.image;
    return p.featured_image && p.featured_image.url ? p.featured_image.url : '';
  };

  // Zeilen des Popups aus der Anfrage (Buybox: id und Menge) und dem neuen Warenkorb; zwei Einzelpfannen in einer
  // Farbe werden eine Zeile mit dem Bild „zwei Pfannen“. Duo 20 % (01.10.2026): ein Pfannen-Duo steht zuerst, mit Name
  // und Farbe wie seine Zeile im Warenkorb und darunter „einzeln …, Du sparst …“ (D4).
  function popupZeilen(o) {
    const k = o.k;
    const antwort = Array.isArray(o.antwort) ? o.antwort : [];
    const idVon = (p) => String(p.variant_id != null ? p.variant_id : p.id);
    const quelle = Array.isArray(o.anfrage) && o.anfrage.length ? o.anfrage.map((x) => ({ id: String(x.id), menge: Number(x.quantity) || 1 })) : antwort.map((p) => ({ id: idVon(p), menge: Number(p.quantity) || 1 }));
    const roh = quelle.map((x) => Object.assign(x, { info: variantenInfo.get(x.id), p: antwort.find((p) => idVon(p) === x.id) || null }));
    const zeileVon = (id) => (k && Array.isArray(k.items) ? k.items.find((z) => String(z.variant_id) === String(id)) : null);
    const preisVon = (x) => {
      const z = zeileVon(x.id);
      return z && Number(z.quantity) ? (Number(z.final_line_price) / Number(z.quantity)) * x.menge : null;
    };
    const farbe = (f) => (D.farben && D.farben[f]) || '';
    const liste = [];
    // Vergleich wie rs-warenkorb-inhalt.liquid: beide Einzelpreise mal Menge gegen den Listenpreis des Pfannen-Duos mal
    // Menge (vor Rabattcodes), nur mit beiden Einzelpfannen bestellbar und echter Ersparnis; ungestrichen, ohne Minus
    const duoVergleich = (x) => {
      const ef = (P.einzel && P.einzel[x.info.f]) || {};
      const ea = ef[x.info.a];
      const eb = ef[x.info.b];
      if (!ea || !eb || ea.verfuegbar === false || eb.verfuegbar === false) return '';
      const z = zeileVon(x.id);
      const dv = (P.duoVarianten || {})[x.info.a + '-' + x.info.b + '|' + x.info.f];
      const listenpreis = z && z.original_price != null ? Number(z.original_price) : dv ? Number(dv.preis) : NaN;
      const einzeln = (Number(ea.preis) + Number(eb.preis)) * x.menge;
      const duo = listenpreis * x.menge;
      if (!Number.isFinite(einzeln) || !Number.isFinite(duo) || einzeln <= duo) return '';
      return fest(fuellen(T.duo_vergleich, { einzeln: geld(einzeln), ersparnis: geld(einzeln - duo) }));
    };
    roh
      .filter((x) => x.info && x.info.art === 'duo')
      .forEach((x) => {
        const f = x.info.f;
        liste.push({
          name: fest((x.menge > 1 ? x.menge + ' × ' : '') + duoName(x.info.a, x.info.b, x.p && x.p.product_title)),
          zeile: fuellen(T.zeile_farbe, { farbe: farbe(f) }),
          bild: bildVon('zwei', f) || bildAusPosten(x.p) || bildVon('eine', f),
          breit: true,
          f,
          g: x.info.b,
          preis: preisVon(x),
          vergleich: duoVergleich(x)
        });
      });
    const einzel = roh.filter((x) => x.info && x.info.art === 'einzel');
    const stueck = einzel.reduce((t, x) => t + x.menge, 0);
    if (stueck === 2 && einzel.every((x) => x.info.f === einzel[0].info.f)) {
      const gr = [];
      einzel.forEach((x) => {
        for (let n = 0; n < x.menge; n++) gr.push(x.info.g);
      });
      gr.sort((a, b) => a - b);
      const preise = einzel.map(preisVon);
      const f = einzel[0].info.f;
      liste.push({
        name: fest(fuellen(gr[0] === gr[1] ? T.popup_zwei_gleich : T.popup_zwei, { a: gr[0], b: gr[1] })),
        zeile: fuellen(T.zeile_farbe, { farbe: farbe(f) }),
        bild: bildVon('zwei', f) || bildVon('eine', f),
        breit: true,
        f,
        g: gr[1],
        preis: preise.every((p) => p != null) ? preise.reduce((t, p) => t + p, 0) : null
      });
    } else {
      einzel.forEach((x) => {
        const g = x.info.g;
        liste.push({
          name: fest((x.menge > 1 ? x.menge + ' × ' : '') + ((D.held && D.held[g]) || '') + ', ' + g + ' cm'),
          zeile: fuellen(T.zeile_farbe, { farbe: farbe(x.info.f) }),
          bild: bildVon('eine', x.info.f),
          breit: true,
          f: x.info.f,
          g,
          preis: preisVon(x)
        });
      });
    }
    roh
      .filter((x) => !x.info || (x.info.art !== 'einzel' && x.info.art !== 'duo'))
      .forEach((x) => {
        const menge = x.menge > 1 ? x.menge + ' × ' : '';
        if (x.info && x.info.art === 'set') {
          liste.push({ name: menge + T.name_set, zeile: fest(fuellen(T.zeile_set, { farbe: farbe(x.info.f) })), bild: bildVon('set', x.info.f), breit: !!(D.bilder && D.bilder.setBreit && D.bilder.setBreit[x.info.f]), preis: preisVon(x) });
        } else if (x.info && x.info.art === 'bambus') {
          liste.push({ name: menge + T.name_bambus, zeile: '', bild: (D.bilder && D.bilder.bambus) || '', bambus: true, preis: preisVon(x) });
        } else {
          const p = x.p || {};
          const vt = p.variant_title && p.variant_title !== 'Default Title' ? p.variant_title : '';
          liste.push({ name: menge + (p.product_title || p.title || ''), zeile: vt, bild: bildAusPosten(p), preis: preisVon(x) });
        }
      });
    return liste;
  }

  function popupFuellen(o, ergebnis) {
    const ul = popup.querySelector('[data-rs-wk-popup-liste]');
    const summeZeile = popup.querySelector('[data-rs-wk-popup-summe-zeile]');
    const box = popup.querySelector('[data-rs-wk-versand]');
    fehlerIn(popup.querySelector('[data-rs-wk-popup-fehler]'), o.k ? '' : T.popup_fehler || T.fehler_sonst);
    if (ul) {
      ul.textContent = '';
      (o.k ? popupZeilen(o) : []).forEach((z) => {
        const li = klon('popup-zeile');
        if (!li) return;
        const bildFeld = feld(li, 'bild');
        if (z.bild) {
          const img = doc.createElement('img');
          img.src = z.bild;
          img.alt = '';
          img.decoding = 'async';
          img.className = z.breit ? 'rs-wk-position__foto rs-wk-position__foto--breit' : 'rs-wk-position__foto';
          bildFeld.appendChild(img);
        } else if (z.bambus && vorlage('popup-bambus')) {
          bildFeld.appendChild(vorlage('popup-bambus').content.cloneNode(true));
        } else if (z.f) {
          const m = doc.createElement('span');
          m.className = 'rs-wk-mini rs-wk-mini--f' + z.f;
          m.style.setProperty('--d', String(RAND_CM[z.g] || 27.5));
          bildFeld.appendChild(m);
        }
        feld(li, 'name').textContent = z.name;
        textOhneBindestrichUmbruch(feld(li, 'zeile'), z.zeile || '');
        feld(li, 'preis').textContent = z.preis != null ? geld(Math.round(z.preis)) : '';
        // Duo 20 % (01.10.2026): Vergleich unter dem Pfannen-Duo, bei allen anderen Zeilen leer
        const vergleichEl = feld(li, 'vergleich');
        if (vergleichEl) vergleichEl.textContent = z.vergleich || '';
        ul.appendChild(li);
      });
      ul.hidden = !ul.children.length;
    }
    if (summeZeile) {
      summeZeile.hidden = !o.k;
      if (o.k) {
        summeZeile.querySelector('[data-rs-wk-popup-summe-name]').textContent = fuellen(T.popup_summe, { anzahl: Number(o.k.item_count) || 0 });
        // E-169: „{anzahl} Artikel“ als eigene kleine Zeile unter „Warenkorb gesamt“. Steht {anzahl} noch in
        // popup_summe (alter Text aus dem Editor), bleibt sie leer, damit die Zahl nicht doppelt erscheint.
        const anzahlEl = summeZeile.querySelector('[data-rs-wk-popup-anzahl]');
        if (anzahlEl) {
          anzahlEl.textContent = /\{anzahl\}/.test(String(T.popup_summe || '')) ? '' : fuellen(T.popup_anzahl || '', { anzahl: Number(o.k.item_count) || 0 });
        }
        summeZeile.querySelector('[data-rs-wk-popup-summe]').textContent = geld(Number(o.k.total_price) || 0);
      }
    }
    if (!box) return null;
    box.hidden = !o.k;
    if (!o.k) return null;
    const s = schwelle();
    const nachT = Number(o.k.total_price) || 0;
    const vorT = o.vorher ? Number(o.vorher.total_price) || 0 : nachT;
    const frei = s > 0 && nachT >= s;
    const warFrei = s > 0 && vorT >= s;
    const botschaft = box.querySelector('[data-rs-wk-versand-botschaft]');
    const span = botschaft && botschaft.querySelector('span');
    const setzen = (istFrei) => {
      box.setAttribute('data-frei', String(istFrei));
      if (botschaft) botschaft.setAttribute('data-frei', String(istFrei));
      if (span) span.textContent = istFrei ? T.versand_erreicht : versandText(ergebnis) || T.versand_rueckfall;
    };
    const wirdFrei = frei && !warFrei;
    // Prüfung E-158: Text und Ansage stimmen sofort; wird der Versand gerade frei, bleibt die Tomate sichtbar
    // (data-frei am Behälter noch false) und die Botschaft verborgen, bis sie im Topf gelandet ist
    setzen(frei);
    if (wirdFrei) {
      box.setAttribute('data-frei', 'false');
      box.classList.add('ist-unterwegs');
    }
    box.style.setProperty('--anteil', String(o.vorher ? anteilVon(o.vorher) : anteilVon(o.k)));
    const nachher = () => {
      box.classList.remove('ist-unterwegs');
      setzen(frei);
    };
    return { box, von: o.vorher ? anteilVon(o.vorher) : anteilVon(o.k), nach: anteilVon(o.k), wirdFrei, nachher, gesamt: nachT };
  }

  // Zeigt das Popup; erfüllt sich, sobald es steht (Handschlag E-23). Die Versandzeile läuft danach weiter.
  async function popupZeigen(o) {
    if (!popup) return;
    await wkCssBereit();
    let ergebnis = null;
    if (o.k) {
      try {
        ergebnis = kartenRechnen(await preise(), o.k);
      } catch (e) {
        ergebnis = null;
      }
    }
    const v = popupFuellen(o, ergebnis);
    if (o.ausloeser) popupAusloeser = o.ausloeser;
    popupOben();
    const warOffen = popupOffen;
    popup.hidden = false;
    popupOffen = true;
    popupFolgenAn(true);
    html.classList.add('rs-warenkorb-offen');
    if (tastatur) popup.setAttribute('data-rs-tastatur', '');
    if (ruhig() || warOffen) popup.classList.add('ist-offen');
    else window.requestAnimationFrame(() => window.requestAnimationFrame(() => popup.classList.add('ist-offen')));
    const titel = popup.querySelector('[data-rs-fokus="titel"]');
    if (titel) titel.focus({ preventScroll: true });
    if (!warOffen) senden('rs:warenkorb:geoeffnet', { popup: true });
    if (v) {
      warte(ruhig() ? 0 : 320)
        .then(() => (popupOffen ? versandBewegen(v.box, v.von, v.nach, { wirdFrei: v.wirdFrei, nachher: v.nachher }) : v.nachher()))
        .then(() => {
          if (v.wirdFrei) senden('rs:versand:frei', { gesamt: v.gesamt });
        });
    }
  }

  function popupSchliessen() {
    if (!popup || !popupOffen) return;
    popupOffen = false;
    popupFolgenAn(false);
    const fokusDrin = popup.contains(doc.activeElement);
    popup.classList.remove('ist-offen');
    html.classList.remove('rs-warenkorb-offen');
    const weg = () => {
      if (!popupOffen) popup.hidden = true;
    };
    if (ruhig()) weg();
    else window.setTimeout(weg, 300);
    senden('rs:warenkorb:geschlossen', { popup: true });
    const a = popupAusloeser;
    popupAusloeser = null;
    if (fokusDrin || doc.activeElement === doc.body) fokusZurueck(a);
  }

  function schliessen() {
    if (!offen || schliesst) return;
    schliesst = true;
    drawer.classList.remove('ist-offen');
    const fertig = () => {
      // Runde Seitenleiste 2: nicht schließen, wenn sie währenddessen wieder geöffnet wurde (oeffnen)
      if (!schliesst) return;
      // Rumpf nach oben, solange die Ebene noch steht (zu wäre scrollTop wirkungslos): jedes Öffnen beginnt oben
      const rumpf = drawer.querySelector('.rs-wk-drawer__rumpf');
      if (rumpf) rumpf.scrollTop = 0;
      // Runde Seitenleiste 3: im Querformat scrollt die ganze Schublade (rs-warenkorb.css)
      const panel = drawer.querySelector('.rs-wk-drawer');
      if (panel) panel.scrollTop = 0;
      if (hatDialog && drawer.open) drawer.close();
      else {
        drawer.removeAttribute('open');
        nachSchliessen();
      }
    };
    // Runde Seitenleiste 2: Ende der Fahrt statt fester 300 ms (die Zeit steht jetzt im Blatt, --rs-wk-zu)
    if (ruhig()) fertig();
    else fahrtEnde(false).then(fertig);
  }

  if (drawer) {
    // Die Scroll-Sperre löst sich im close-Ereignis, egal wie der Dialog geschlossen wurde (05 6.16)
    drawer.addEventListener('close', nachSchliessen);
    drawer.addEventListener('cancel', (e) => {
      e.preventDefault();
      schliessen();
    });
    // Runde Seitenleiste 3: Klappt der Rabattcode (zuletzt im Rumpf) auf, rollt das Formular ins Bild, sobald rs-fragen.js
    // fertig aufgeklappt hat (260 ms)
    drawer.addEventListener(
      'toggle',
      (e) => {
        const d = e.target;
        if (!(d instanceof Element) || !d.matches('details.rs-wk-code') || !d.open) return;
        window.setTimeout(() => imRumpfZeigen(d.querySelector('[data-rs-wk-code-form]')), ruhig() ? 0 : 300);
      },
      true
    );
    if (!D.warenkorbseite) {
      alle('a.header__icon--cart').forEach((a) => {
        a.setAttribute('aria-haspopup', 'dialog');
        a.setAttribute('aria-controls', drawer.id);
      });
    }
  }

  // Escape und Fokusfalle am Dokument, damit sie auch nach dem Neuzeichnen greifen (Vorschau 10)
  const FOKUSSIERBAR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  // Fokusziele im Drawer in Dokumentreihenfolge, auch in offenen Shadow-Roots (Shopifys Express-Knöpfe),
  // ohne den Fokuswächter
  function fokusZiele(wurzel) {
    const liste = [];
    const sammeln = (knoten) => {
      Array.from(knoten.children || []).forEach((el) => {
        if (el.matches(FOKUSSIERBAR) && !el.hasAttribute('data-rs-wk-waechter')) liste.push(el);
        if (el.shadowRoot) sammeln(el.shadowRoot);
        sammeln(el);
      });
    };
    sammeln(wurzel);
    return liste.filter((el) => el.getClientRects().length && !el.closest('[hidden]'));
  }

  // Runde Seitenleiste 2 (10.10.2026): Die Schublade hat keine Express-Knöpfe mehr (fremde iframes), damit auch keinen
  // Fokuswächter; Tab kreist über das keydown unten, Escape greift überall.
  // Popup (E-158): Escape schließt es, außer ein anderer Dialog ist offen (der bekommt das Escape) oder jemand hat es
  // schon verwendet (Suchfeld). Tab aus dem letzten Knopf oder Umschalt+Tab aus Kopf und Kreuz schließt es und gibt
  // den Fokus an den Auslöser zurück, statt ihn an den Seitenanfang oder in den Kopf springen zu lassen (nicht modal).
  doc.addEventListener('keydown', (e) => {
    if (!popupOffen || euOffen || offen || e.defaultPrevented) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (doc.querySelector('dialog[open]')) return;
      e.preventDefault();
      popupSchliessen();
      return;
    }
    if (e.key !== 'Tab' || !popup.contains(doc.activeElement)) return;
    const ziele = fokusZiele(popup);
    if (!ziele.length) return;
    const aktiv = doc.activeElement;
    const titel = popup.querySelector('[data-rs-fokus="titel"]');
    const raus = e.shiftKey ? aktiv === ziele[0] || aktiv === titel : aktiv === ziele[ziele.length - 1];
    if (!raus) return;
    e.preventDefault();
    popupSchliessen();
  });

  doc.addEventListener('keydown', (e) => {
    if (!offen || euOffen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      schliessen();
      return;
    }
    // Runde Seitenleiste 3: Pfeiltasten blättern die Bewertungen, solange ihre Liste den Fokus hat; nicht mit Alt, Strg,
    // Cmd oder Umschalt (Alt mit Pfeil ist im Browser „Zurück“)
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && e.target instanceof Element && e.target.hasAttribute('data-rs-wk-bew-band')) {
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      e.preventDefault();
      bewBlaettern(e.target, e.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    if (e.key !== 'Tab') return;
    const ziele = fokusZiele(drawer);
    if (!ziele.length) return;
    const erstes = ziele[0];
    const letztes = ziele[ziele.length - 1];
    const titel = drawer.querySelector('[data-rs-fokus="titel"]');
    const aktiv = doc.activeElement;
    if (!drawer.contains(aktiv)) {
      e.preventDefault();
      (e.shiftKey ? letztes : erstes).focus();
    } else if (e.shiftKey && (aktiv === erstes || aktiv === titel)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && aktiv === letztes) {
      e.preventDefault();
      erstes.focus();
    }
  });

  /* ---------- Klicks und Formulare ---------- */

  doc.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t || e.defaultPrevented) return;

    const eu = t.closest('[data-rs-eu-oeffnen]');
    if (eu) {
      if (typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function') {
        e.preventDefault();
        euOeffnen(eu);
      }
      return;
    }

    if (popup && t.closest('[data-rs-wk-popup-zu]')) {
      e.preventDefault();
      popupSchliessen();
      return;
    }

    // Ohne Schublade (Popup, E-158) führt der Topf wie live auf die Warenkorbseite
    const topf = t.closest('a.header__icon--cart');
    if (topf && drawer && !D.warenkorbseite) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      oeffnen({ ausloeser: topf });
      return;
    }

    const k = t.closest('[data-rs-wk-aktion]');
    if (!k || !ansichtVon(k)) return;
    const aktion = k.getAttribute('data-rs-wk-aktion');
    switch (aktion) {
      case 'schliessen':
        e.preventDefault();
        schliessen();
        break;
      case 'plus':
      case 'minus':
      case 'entfernen':
        e.preventDefault();
        mengeKlick(k, aktion);
        break;
      case 'bambus':
        e.preventDefault();
        dazuKlick(k);
        break;
      case 'tausch':
        e.preventDefault();
        tauschKlick(k);
        break;
      case 'rueck':
        e.preventDefault();
        rueckKlick(k);
        break;
      case 'zitat':
        e.preventDefault();
        zitatUmschalten(k);
        break;
      case 'karten-zurueck':
        e.preventDefault();
        blaettern(k, -1);
        break;
      case 'karten-weiter':
        e.preventDefault();
        blaettern(k, 1);
        break;
      case 'bew-zurueck':
      case 'bew-weiter':
        e.preventDefault();
        bewBlaettern(k, aktion === 'bew-weiter' ? 1 : -1);
        break;
      case 'code-weg':
        e.preventDefault();
        codeWeg(k);
        break;
      case 'weiter':
        // Auf der Seite mit Kaufbühne schließt „Weiter einkaufen“ nur den Drawer (04 A5.2)
        if (offen && doc.getElementById('auswahl')) {
          e.preventDefault();
          schliessen();
        }
        break;
      case 'auswahl': {
        // „Zur Auswahl“ springt zur Buybox, wenn sie auf der Seite steht (04 A5.11, E-46)
        const ziel = doc.getElementById('auswahl');
        if (offen && ziel) {
          e.preventDefault();
          naechsterFokus = ziel;
          schliessen();
        }
        break;
      }
      case 'sprung': {
        // Sprunglinks im Drawer (#bewertungen, #probekochen, Feedback Runde 1): Steht das Ziel auf dieser
        // Seite, schließt der Drawer und die Seite rollt dorthin; sonst folgt der Link seiner Adresse.
        const href = k.getAttribute('href') || '';
        const raute = href.indexOf('#');
        const ziel = raute >= 0 ? doc.getElementById(href.slice(raute + 1)) : null;
        if (offen && ziel && !drawer.contains(ziel)) {
          e.preventDefault();
          naechsterFokus = ziel;
          schliessen();
        }
        break;
      }
      default:
        break;
    }
  });

  doc.addEventListener('submit', (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (f.hasAttribute('data-rs-wk-kasse-form')) {
      // Läuft noch eine Änderung, erst danach zur Kasse
      if (laufend) {
        e.preventDefault();
        kette.then(() => {
          const h = doc.createElement('input');
          h.type = 'hidden';
          h.name = 'checkout';
          h.value = '';
          f.appendChild(h);
          f.submit();
        });
      }
      return;
    }
    if (f.hasAttribute('data-rs-wk-code-form')) {
      e.preventDefault();
      // Runde Seitenleiste 3: Der Rabattcode steht zuletzt im Rumpf, ein Nachlass im festen Fuß macht den Rumpf kürzer;
      // danach rollt der Rumpf die Meldung ins Bild (nur in der Schublade)
      const lauf = codeEinloesen(f);
      if (lauf && drawer && drawer.contains(f)) {
        lauf.then(() => {
          const ok = f.querySelector('[data-rs-wk-code-ok]');
          const fb = f.querySelector('[data-rs-wk-code-fehler]');
          imRumpfZeigen(ok && ok.textContent ? ok : fb && fb.textContent ? fb : null);
        });
      }
      return;
    }
    const pos = f.closest('[data-rs-wk-position]');
    if (pos && ansichtVon(f)) {
      e.preventDefault();
      const knopf = e.submitter;
      if (knopf && knopf.hasAttribute('data-rs-wk-aktion')) mengeKlick(knopf, knopf.getAttribute('data-rs-wk-aktion'));
    }
  });

  /* ---------- Ereignisse der Buybox (05 8.2, 8.6, 4.4) ---------- */

  hoeren('rs:warenkorb:hinzugefuegt', (e) => {
    const d = e.detail || {};
    if (d.quelle === 'warenkorb') return;
    let fertig;
    const geoeffnet = new Promise((r) => {
      fertig = r;
    });
    try {
      d.geoeffnet = geoeffnet;
    } catch (x) {
      /* detail ist eingefroren: dann bleibt nur rs:warenkorb:geoeffnet */
    }
    const ziel = e.target instanceof Element ? e.target : null;
    const ausloeser = ziel || (doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null);
    const posten = d.antwort && Array.isArray(d.antwort.items) ? d.antwort.items : [];
    posten.forEach((p) => {
      const info = variantenInfo.get(String(p.variant_id != null ? p.variant_id : p.id));
      if (info && info.f) zuletztFarbe = info.f;
    });
    if (d.farbe != null && (String(d.farbe) === '1' || String(d.farbe) === '2')) zuletztFarbe = String(d.farbe);
    const auswahl =
      d.auswahl ||
      posten
        .map((p) => (p.quantity > 1 ? p.quantity + ' × ' : '') + auswahlName(p.variant_id != null ? p.variant_id : p.id, p.product_title))
        .filter(Boolean)
        .join(' und ');
    const vorher = korb;
    hinweise = [];
    fehlerLeeren();
    // Runde Seitenleiste 2: Skripte der Schublade laden, solange der Flug läuft (nicht erst im ersten Bild der Fahrt)
    if (!popup) drawerVorbereiten();
    einreihen(async () => {
      // Sofort holen, aber erst nach der Landung einsetzen (4.4, 8.3)
      const [k, sek] = await Promise.all([holeKorb(), sektionenOderFehler()]);
      if (!popup) bilderWaermen(sek.s);
      if (d.landung && typeof d.landung.then === 'function') {
        try {
          await d.landung;
        } catch (x) {
          /* Flug abgebrochen: trotzdem einsetzen */
        }
      }
      let fehler = sek.fehler;
      try {
        await anwenden(k, sek.s, { art: 'hinzu', auswahl, vorher, leise: true, versandSpaeter: true, ohneBewegung: !popup });
      } catch (x) {
        fehler = fehler || x;
      }
      if (popup) {
        // E-158: das kleine Popup statt der Schublade; die Tomate landet dort, danach rs:versand:frei
        await popupZeigen({ k, vorher, anfrage: d.items, antwort: posten, ausloeser });
        // Ladezeit-Runde 03.10.2026 (B9): die Warenkorbseite im Leerlauf vorladen
        wkLeerlauf(warenkorbVorladen, 1000);
        sprich(ansageText(vorher, k, { art: 'hinzu', auswahl }));
        return;
      }
      // 09.10.2026: erst mit dem Blatt öffnen (auf Kaufseiten lädt es ohne zu blockieren), dann ansagen; sonst kam die
      // Ansage bei noch geschlossener Schublade und der Handschlag (E-23) war vor dem Öffnen erfüllt
      await wkCssBereit();
      oeffnen({ ausloeser, auffrischen: false, huepfen: false });
      sprich(ansageText(vorher, k, { art: 'hinzu', auswahl }));
      versandNachOeffnen(vorher, k);
      // Section fehlt oder ließ sich nicht einsetzen: Meldung im offenen Drawer statt still „leer“
      if (fehler) fehlerAllgemein(fehler);
    })
      .catch((x) => {
        if (popup) return popupZeigen({ k: null, vorher, anfrage: d.items, antwort: posten, ausloeser });
        fehlerAllgemein(x);
        oeffnen({ ausloeser });
        return null;
      })
      .finally(() => fertig(true));
  });

  hoeren('rs:warenkorb:oeffnen', (e) => {
    // Ohne Schublade (Popup, E-158): zur Warenkorbseite
    if (!drawer) {
      if (!D.warenkorbseite) window.location.href = D.routen.warenkorb;
      return;
    }
    const d = e.detail || {};
    const ziel = e.target instanceof Element ? e.target : null;
    oeffnen({ ausloeser: d.ausloeser || ziel });
  });

  // Rückkehr per Zurück-Taste aus dem Seiten-Cache: Stand frisch laden (05 8.3)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) einreihen(() => nachladen({ art: 'stand', leise: true })).catch(() => null);
  });

  /* ---------- Warenkorbseite vorladen (Ladezeit-Runde 03.10.2026, B9) ----------
     Geht nach dem Hinzufügen das Popup auf, lädt Chrome die Warenkorbseite vor: script type=speculationrules mit
     prefetch, eagerness immediate, nur das HTML, ohne es auszuführen, also ohne Tracking (wie A4 auf der Startseite).
     „Warenkorb ansehen“ und der Topf öffnen sie dann ohne Warten auf den Server (/cart wird für jeden Aufruf gerechnet).
     Im Leerlauf nach dem Öffnen; nichts bei saveData, im Theme-Editor, auf der Warenkorbseite oder ohne Unterstützung
     (Safari, Firefox). Kein prerender: die Seite liefe sonst samt Pixeln im Hintergrund.
     Vorgeladenes HTML trägt den Stand von damals. Ändert sich der Warenkorb danach (rs:warenkorb:geaendert, etwa ein
     Tausch im Popup), ersetzt eine frische Regel die alte. Ob Chrome dann frisch lädt, regelt der Browser; darum gleicht
     eine Warenkorbseite, die aus einem Vorladen kommt (deliveryType navigational-prefetch), beim Start mit GET /cart.js
     ab und holt die Section nur bei anderem Stand (seiteAbgleichen, wie nach „Zurück“). */
  let vorladenRegel = null;
  let vorladenStand = '';
  function warenkorbVorladen() {
    const ziel = D.routen && D.routen.warenkorb;
    if (!ziel || D.warenkorbseite || (window.Shopify && window.Shopify.designMode)) return;
    const netz = navigator.connection;
    if (netz && netz.saveData) return;
    const S = window.HTMLScriptElement;
    if (!S || typeof S.supports !== 'function' || !S.supports('speculationrules')) return;
    const stand = standVon(korb);
    if (vorladenRegel && vorladenRegel.isConnected && stand === vorladenStand) return;
    if (vorladenRegel) vorladenRegel.remove();
    const regel = doc.createElement('script');
    regel.type = 'speculationrules';
    regel.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [ziel], eagerness: 'immediate' }] });
    doc.head.appendChild(regel);
    vorladenRegel = regel;
    vorladenStand = stand;
  }
  doc.addEventListener('rs:warenkorb:geaendert', () => {
    if (vorladenRegel) warenkorbVorladen();
  });

  function ausVorladen() {
    try {
      const p = window.performance;
      const n = p && typeof p.getEntriesByType === 'function' ? p.getEntriesByType('navigation')[0] : null;
      return !!n && n.deliveryType === 'navigational-prefetch';
    } catch (e) {
      return false;
    }
  }
  async function seiteAbgleichen() {
    const k = await holeKorb();
    if (standVon(k) === standVon(korb)) {
      korb = k;
      return;
    }
    const { s, fehler } = await sektionenOderFehler();
    await anwenden(k, s, { art: 'stand', leise: true });
    if (fehler) throw fehler;
  }

  let groesseWartet = false;
  window.addEventListener(
    'resize',
    () => {
      if (groesseWartet) return;
      groesseWartet = true;
      window.requestAnimationFrame(() => {
        groesseWartet = false;
        alle('.rs-wk-karten__liste').forEach((l) => l.rsPruefen && l.rsPruefen());
      });
    },
    { passive: true }
  );

  /* ---------- Start ---------- */

  // Stand beim Laden; im Popup-Modus steht er im Popup (E-158), sonst fehlte beim ersten Kauf der alte Stand
  const startAnsicht = drawer || seite || popup;
  const erster = startAnsicht && jsonAus(startAnsicht, 'script[data-rs-wk-korb]');
  korb = erster || null;

  preise().then((R) => {
    const ergebnis = kartenRechnen(R, korb);
    ansichten().forEach((a) => {
      kartenZeichnen(a, ergebnis);
      versandZeichnen(a, ergebnis);
    });
  });
  leisteBeobachten();
  wkExpressBeobachten();
  // Runde Seitenleiste 2: liegt schon Ware im Warenkorb, Skripte und Positionsbilder der Schublade im Leerlauf laden
  if (drawer && !D.warenkorbseite && korb && Number(korb.item_count) > 0) {
    wkLeerlauf(
      () => {
        drawerVorbereiten();
        bilderVorladen();
      },
      3000,
      1500
    );
  }

  // E-158: Auf der Warenkorbseite hüpft die Tomate zweimal, sobald die Versandzeile zum ersten Mal zu sehen ist
  const ersteVersandzeile = seite && seite.querySelector('[data-rs-wk-versand]');
  if (ersteVersandzeile && 'IntersectionObserver' in window) {
    const beob = new IntersectionObserver((eintraege) => {
      if (!eintraege.some((x) => x.isIntersecting)) return;
      beob.disconnect();
      window.setTimeout(() => {
        const box = seite.querySelector('[data-rs-wk-versand]');
        if (box) tomateHuepfen(box);
      }, 500);
    });
    beob.observe(ersteVersandzeile);
  }

  // E-161 (Denny: „springt einmal, zweimal und dann passiert gar nichts … alle paar Sekunden springen“): danach
  // höchstens 4 Einzelhüpfer im Abstand von 10 s, nur wenn die Tomate wirklich im Fenster steht, unter der Schwelle,
  // bei sichtbarem Tab, ohne laufende Änderung und ohne Zeiger oder Fokus in der Versandzeile. Die Box wird bei jedem
  // Takt neu gesucht, nach jedem Neuzeichnen ist es ein neuer Knoten. Je Seitenaufruf ein Doppel- und höchstens vier
  // Einzelhüpfer, zusammen unter 5 s (WCAG 2.2.2, R71). Nur Klassen, kein Ereignis, kein Speicher.
  // Ladezeit-Runde 03.10.2026 (B7): Findet der Takt dreimal hintereinander keine Tomate im Fenster (Popup und Schublade
  // zu, Versand schon frei, Versandzeile außer Sicht), endet er; früher suchte und maß er auf jeder Seite mit verborgenem
  // Popup alle 10 s ohne Ende. Wieder an geht er beim Öffnen von Popup oder Schublade (rs:warenkorb:geoeffnet), nach
  // jeder Änderung (rs:warenkorb:geaendert) und auf der Warenkorbseite, sobald die Versandzeile von außen ins Bild kommt
  // (nachhuepferWeckerStellen). Die vier Einzelhüpfer je Seitenaufruf bleiben die Grenze, nie laufen zwei Takte zugleich.
  // Verborgener Tab, laufende Änderung oder ein Hüpfer vor weniger als 5 s zählen nicht als Fehlversuch.
  const NACHHUEPFER_MAX = 4;
  const NACHHUEPFER_FEHL_MAX = 3;
  let nachhuepfer = 0;
  let nachhuepferFehl = 0;
  let nachhuepferTakt = 0;
  let nachhuepferWecker = null;
  function tomateNachhuepfen() {
    if (nachhuepferTakt || nachhuepfer >= NACHHUEPFER_MAX || ruhig()) return;
    if (nachhuepferFehl >= NACHHUEPFER_FEHL_MAX) {
      nachhuepferWeckerStellen();
      return;
    }
    nachhuepferTakt = window.setTimeout(() => {
      nachhuepferTakt = 0;
      if (!doc.hidden && !laufend && Date.now() - letzterHuepfer > 5000) {
        const box = alle('[data-rs-wk-versand]').find((b) => {
          const t = b.querySelector('[data-rs-tomate]');
          if (!t || b.getAttribute('data-frei') === 'true' || b.matches(':hover') || b.contains(doc.activeElement)) return false;
          const r = t.getBoundingClientRect();
          return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
        });
        if (box) {
          tomateHuepfen(box, true);
          nachhuepfer += 1;
          nachhuepferFehl = 0;
        } else nachhuepferFehl += 1;
      }
      tomateNachhuepfen();
    }, 10000);
  }
  // Warenkorbseite (B7): Nach dem Ende wartet ein Beobachter ohne Takt auf die Versandzeile. Er weckt erst, wenn sie
  // außer Sicht war und wieder ins Bild kommt; stand sie beim Ende im Bild (Versand frei, Zeiger oder Fokus darin),
  // begänne der Takt sonst sofort von vorn. Nach einer Änderung ist die Zeile ein neuer Knoten: rs:warenkorb:geaendert
  // weckt den Takt, ein neues Ende beobachtet dann den neuen Knoten.
  function nachhuepferWeckerStellen() {
    const box = seite && seite.querySelector('[data-rs-wk-versand]');
    if (nachhuepferWecker || !box || !('IntersectionObserver' in window)) return;
    let draussen = false;
    nachhuepferWecker = new IntersectionObserver((eintraege) => {
      if (!eintraege[eintraege.length - 1].isIntersecting) draussen = true;
      else if (draussen) nachhuepferWecken();
    });
    nachhuepferWecker.observe(box);
  }
  function nachhuepferWecken() {
    if (nachhuepferWecker) nachhuepferWecker.disconnect();
    nachhuepferWecker = null;
    nachhuepferFehl = 0;
    tomateNachhuepfen();
  }
  tomateNachhuepfen();
  doc.addEventListener('rs:warenkorb:geoeffnet', nachhuepferWecken);
  doc.addEventListener('rs:warenkorb:geaendert', nachhuepferWecken);

  // 09.10.2026: /cart leitet mit #warenkorb hierher (rs-warenkorb-drawer.liquid); die Schublade öffnet mit frischem Stand,
  // die Raute verschwindet aus der Adresse, damit „Zurück“ und Teilen sie nicht wieder öffnen
  if (drawer && !D.warenkorbseite && window.location.hash === '#warenkorb') {
    try {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    } catch (e) {
      /* ohne History-API bleibt die Raute stehen */
    }
    wkCssBereit().then(() => oeffnen({}));
  }

  // Nach dem Neuladen der Warenkorbseite (etwa „Wieder hineinlegen“ aus dem leeren Zustand):
  // Fokus auf die H1 und Ansage in der Kopf-Region
  merkerEinloesen();

  // Liegen beim Laden nur Bambus-Küchenhelfer im Warenkorb, gilt die Regel sofort
  if (korb && bambusOhnePfanne(korb).length) {
    einreihen(() => nachladen({ art: 'stand' })).catch(fehlerAllgemein);
  }

  // Ladezeit-Runde 03.10.2026 (B9): Kam die Warenkorbseite aus dem Vorladen, mit dem echten Stand abgleichen
  if (seite && ausVorladen()) einreihen(seiteAbgleichen).catch(() => null);

  window.RSWarenkorb = Object.freeze({
    oeffnen: (ausloeser) => {
      if (drawer) return oeffnen({ ausloeser });
      if (!D.warenkorbseite) window.location.href = D.routen.warenkorb;
      return false;
    },
    schliessen,
    aktualisieren: () => einreihen(() => nachladen({ art: 'stand', leise: true }))
  });
})();
